export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: any;
  Date: any;
  DateTime: any;
  URL: any;
  UUID: any;
  Upload: any;
};

export type ActiveTypeMarket = Entity & NamedEntity & Node & {
  __typename?: 'ActiveTypeMarket';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
};

export type ActiveTypeMarketSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type AddCommentaryInput = {
  comment: Scalars['String'];
  id: Scalars['ID'];
};

export type AddFaqInput = {
  answer: Scalars['String'];
  id: Scalars['ID'];
  question: Scalars['String'];
};

export type AddOrUpdateTableConfigurationInput = {
  columns: Array<ColumnInput>;
  tableId: Scalars['String'];
};

export type AddOrUpdateTableConfigurationPayload = {
  __typename?: 'AddOrUpdateTableConfigurationPayload';
  user?: Maybe<User>;
};

export type AddRegulatoryDocumentParagraphCommentaryInput = {
  commentary: AddCommentaryInput;
  paragraphId: Scalars['ID'];
};

export type AddRegulatoryDocumentParagraphCommentaryPayload = {
  __typename?: 'AddRegulatoryDocumentParagraphCommentaryPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type AddRegulatoryDocumentParagraphFaqInput = {
  faqInput: AddFaqInput;
  paragraphId: Scalars['ID'];
};

export type AddRegulatoryDocumentParagraphFaqPayload = {
  __typename?: 'AddRegulatoryDocumentParagraphFaqPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type AggregatedFields = {
  __typename?: 'AggregatedFields';
  vehicleCategories: Array<VehicleCategory>;
};

export type Answer = Entity & {
  __typename?: 'Answer';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  markedAsFinal: Scalars['Boolean'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  text?: Maybe<Scalars['String']>;
};

export type AnswerPayload = {
  __typename?: 'AnswerPayload';
  succeeded: Scalars['Boolean'];
};

export type AppendVersionMetadataInput = {
  distParagraphIds: Array<Scalars['ID']>;
  distRegulatoryDocumentId: Scalars['ID'];
  sourceParagraphIds: Array<Scalars['ID']>;
  sourceRegulatoryDocumentId: Scalars['ID'];
  updateFields: CopyVersionMetadataUpdateFieldsInput;
};

export type AppendVersionMetadataPayload = {
  __typename?: 'AppendVersionMetadataPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type Application = {
  __typename?: 'Application';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  description: Scalars['String'];
  iri: Scalars['String'];
  modifiedAt: Scalars['DateTime'];
  modifiedBy: Scalars['String'];
};

export type ApplicationNode = {
  __typename?: 'ApplicationNode';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  description: Scalars['String'];
  imdsApplication?: Maybe<ImdsApplication>;
  iri: Scalars['String'];
  limits: Array<Limit>;
  modifiedAt: Scalars['DateTime'];
  modifiedBy: Scalars['String'];
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export type ApprovalWorkFlow = {
  __typename?: 'ApprovalWorkFlow';
  approverRefs: Array<User>;
  clearingTimestamp?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  sentToApprovalTimestamp?: Maybe<Scalars['DateTime']>;
};

export type ApprovalWorkFlowFilterInput = {
  and?: InputMaybe<Array<ApprovalWorkFlowFilterInput>>;
  approverRefs?: InputMaybe<ListFilterInputTypeOfEntityRefOfUserFilterInput>;
  clearingTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ApprovalWorkFlowFilterInput>>;
  sentToApprovalTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ApprovalWorkFlowInput = {
  approverRefs: Array<EntityRefOfUserInput>;
  clearingTimestamp?: InputMaybe<Scalars['DateTime']>;
  message?: InputMaybe<Scalars['String']>;
  sentToApprovalTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type ApprovalWorkFlowSortInput = {
  clearingTimestamp?: InputMaybe<SortEnumType>;
  message?: InputMaybe<SortEnumType>;
  sentToApprovalTimestamp?: InputMaybe<SortEnumType>;
};

export type AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareInput = {
  paragraphIds: Array<Scalars['ID']>;
  regulatoryDocumentId: Scalars['ID'];
  requirementRefs: Array<Array<EntityRefOfRequirementInput>>;
};

export type AssignRegulatoryDocumentParagraphsRequirementsDocumentComparePayload = {
  __typename?: 'AssignRegulatoryDocumentParagraphsRequirementsDocumentComparePayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type AssignRegulatoryDocumentParagraphsRequirementsInput = {
  paragraphIds: Array<Scalars['ID']>;
  regulatoryDocumentId: Scalars['ID'];
  requirementRefs: Array<EntityRefOfRequirementInput>;
};

export type AssignRegulatoryDocumentParagraphsRequirementsPayload = {
  __typename?: 'AssignRegulatoryDocumentParagraphsRequirementsPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type AssignRegulatoryDocumentParagraphsTagsInput = {
  paragraphIds: Array<Scalars['ID']>;
  regulatoryDocumentId: Scalars['ID'];
  tagRefs: Array<EntityRefOfTagInput>;
};

export type AssignRegulatoryDocumentParagraphsTagsPayload = {
  __typename?: 'AssignRegulatoryDocumentParagraphsTagsPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type AssignReportConfigurationInput = {
  addedUsers: Array<Scalars['ID']>;
  removedUsers: Array<Scalars['ID']>;
  reportEventType: ReportEventType;
};

export type AssignReportConfigurationPayload = {
  __typename?: 'AssignReportConfigurationPayload';
  user?: Maybe<Array<User>>;
};

export type AssignVehicleProjectPermissionsInput = {
  modelSeries: Scalars['String'];
  users: Array<Scalars['ID']>;
};

export type AssignVehicleProjectPermissionsPayload = {
  __typename?: 'AssignVehicleProjectPermissionsPayload';
  user?: Maybe<Array<User>>;
};

export type AssignVehicleProjectRequirementsInput = {
  addReason: Scalars['String'];
  generation: Scalars['String'];
  isProjectRelevant?: Scalars['Boolean'];
  modelSeries: Scalars['String'];
  projectRelevantComments?: InputMaybe<Scalars['String']>;
  requirementIds: Array<Scalars['ID']>;
};

export type AssignVehicleProjectRequirementsPayload = {
  __typename?: 'AssignVehicleProjectRequirementsPayload';
  vehicleProjectMaster?: Maybe<VehicleProjectMaster>;
};

export type AssignedRequirement = {
  __typename?: 'AssignedRequirement';
  addReason: Scalars['String'];
  added: Scalars['DateTime'];
  addedAutomatically: Scalars['Boolean'];
  isProjectRelevant: Scalars['Boolean'];
  projectRelevantComments?: Maybe<Scalars['String']>;
  requirement: Requirement;
  vehicleProjectsRefs: Array<EntityRefOfVehicleProject>;
};

export type AssignedRequirementFilterOptions = {
  __typename?: 'AssignedRequirementFilterOptions';
  addedAutomaticallyOptions: Array<Scalars['String']>;
  vehicleProjectOptions: Array<FilterOption>;
};

export type AssignedRequirementRef = {
  __typename?: 'AssignedRequirementRef';
  addReason: Scalars['String'];
  added: Scalars['DateTime'];
  addedAutomatically: Scalars['Boolean'];
  isProjectRelevant: Scalars['Boolean'];
  projectRelevantComments?: Maybe<Scalars['String']>;
  requirementRef: EntityRefOfRequirement;
  status: RequirementStatus;
  vehicleProjectsRefs: Array<EntityRefOfVehicleProject>;
};

export type AssignedRequirementsInfinityResults = {
  __typename?: 'AssignedRequirementsInfinityResults';
  assignedRequirementFilterOptions: AssignedRequirementFilterOptions;
  assignedRequirementsBatch: Array<AssignedRequirement>;
  requirementFilterOptions: RequirementFilterOptions;
  requirementIds: Array<Scalars['String']>;
};

export type AttachmentCategory = Entity & NamedEntity & Node & {
  __typename?: 'AttachmentCategory';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
};

export type AttachmentCategorySortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type AttachmentInput = {
  attachmentId: Scalars['String'];
  categoryId?: InputMaybe<Scalars['ID']>;
  contentType?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  isVkoOnly?: Scalars['Boolean'];
};

export type AttachmentRef = {
  __typename?: 'AttachmentRef';
  attachmentId: Scalars['String'];
  category?: Maybe<AttachmentCategory>;
  file: BlobRef;
  isVkoOnly?: Maybe<Scalars['Boolean']>;
};

export type AuditLog = Node & {
  __typename?: 'AuditLog';
  change: AuditLogChange;
  changeSetId: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  createdBy: User;
  entity?: Maybe<Node>;
  entityId: Scalars['String'];
  entityNodeId: Scalars['String'];
  entityOperation: EntityOperation;
  entityType: Scalars['String'];
  id: Scalars['ID'];
};

export type AuditLogChange = {
  __typename?: 'AuditLogChange';
  key: Scalars['String'];
  nodeId?: Maybe<Scalars['String']>;
  oldNodeId?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['Any']>;
  path: Scalars['String'];
  type: Scalars['String'];
  value?: Maybe<Scalars['Any']>;
  valueType?: Maybe<Scalars['String']>;
};

export type AuditLogChangeFilterInput = {
  and?: InputMaybe<Array<AuditLogChangeFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AuditLogChangeFilterInput>>;
  path?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  valueType?: InputMaybe<StringOperationFilterInput>;
};

export type AuditLogChangeSortInput = {
  key?: InputMaybe<SortEnumType>;
  path?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  valueType?: InputMaybe<SortEnumType>;
};

export type AuditLogFilterInput = {
  and?: InputMaybe<Array<AuditLogFilterInput>>;
  change?: InputMaybe<AuditLogChangeFilterInput>;
  changeSetId?: InputMaybe<UuidOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  entityId?: InputMaybe<StringOperationFilterInput>;
  entityOperation?: InputMaybe<EntityOperationOperationFilterInput>;
  entityType?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IdOperationFilterInput>;
  or?: InputMaybe<Array<AuditLogFilterInput>>;
};

export type AuditLogSortInput = {
  change?: InputMaybe<AuditLogChangeSortInput>;
  changeSetId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  entityId?: InputMaybe<SortEnumType>;
  entityOperation?: InputMaybe<SortEnumType>;
  entityType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AuditLogsConnection = {
  __typename?: 'AuditLogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AuditLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AuditLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AuditLogsEdge = {
  __typename?: 'AuditLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AuditLog;
};

export type BaseUserInput = {
  givenName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  mail?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  surname?: InputMaybe<Scalars['String']>;
  userPrincipalName?: InputMaybe<Scalars['String']>;
};

export type Baseline = Entity & NamedEntity & {
  __typename?: 'Baseline';
  assignedRequirementRefs: Array<AssignedRequirementRef>;
  assignedRequirements: Array<AssignedRequirement>;
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  generation: Scalars['String'];
  id: Scalars['ID'];
  modelSeries: Scalars['String'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  reqIFAttachments: Array<AttachmentRef>;
  transferWorkflow: TransferWorkflow;
};

export type BaselinePayload = {
  __typename?: 'BaselinePayload';
  baseline: Baseline;
};

export type BlobRef = {
  __typename?: 'BlobRef';
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  originalFileName?: Maybe<Scalars['String']>;
  uri: Scalars['URL'];
};

export type BodyworkVariant = Entity & NamedEntity & Node & {
  __typename?: 'BodyworkVariant';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
};

export type BodyworkVariantSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type Category = Entity & NamedEntity & Node & {
  __typename?: 'Category';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  translations?: Maybe<Array<TranslationObject>>;
};


export type CategoryNameArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
};

export type CategorySortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export enum ChangeInfoType {
  Changed = 'CHANGED',
  Deleted = 'DELETED',
  New = 'NEW',
  None = 'NONE',
  Obsolete = 'OBSOLETE',
  Unchanged = 'UNCHANGED'
}

export type ChangeInfoTypeOperationFilterInput = {
  eq?: InputMaybe<ChangeInfoType>;
  in?: InputMaybe<Array<ChangeInfoType>>;
  neq?: InputMaybe<ChangeInfoType>;
  nin?: InputMaybe<Array<ChangeInfoType>>;
};

export type CheckVersionNameRegulatoryDocumentInput = {
  regulationId: Scalars['ID'];
  regulatoryDocumentName: Scalars['String'];
};

export type CheckVersionNameRegulatoryDocumentPayload = {
  __typename?: 'CheckVersionNameRegulatoryDocumentPayload';
  boolean?: Maybe<Scalars['Boolean']>;
};

export type ClearFieldForAllParagraphsInput = {
  fieldName: Scalars['String'];
  regulatoryDocumentId: Scalars['ID'];
};

export type ClearFieldForAllParagraphsPayload = {
  __typename?: 'ClearFieldForAllParagraphsPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type ClearFieldForSelectedParagraphsInput = {
  fieldName: Scalars['String'];
  paragraphIds: Array<Scalars['ID']>;
  regulatoryDocumentId: Scalars['ID'];
};

export type ClearFieldForSelectedParagraphsPayload = {
  __typename?: 'ClearFieldForSelectedParagraphsPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type CloneAllParagraphsForRegulatoryDocumentInput = {
  distRegulatoryDocument: Scalars['ID'];
  sourceRegulatoryDocument: Scalars['ID'];
};

export type CloneAllParagraphsForRegulatoryDocumentPayload = {
  __typename?: 'CloneAllParagraphsForRegulatoryDocumentPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type CloneRegulatoryDocumentInput = {
  originalRegulatoryDocumentId: Scalars['ID'];
  reapprovingVKO?: InputMaybe<EntityRefOfUserInput>;
  workflowStatus: WorkflowStatus;
};

export type Column = {
  __typename?: 'Column';
  hidden: Scalars['Boolean'];
  key: Scalars['String'];
  width: Scalars['Int'];
};

export type ColumnInput = {
  hidden: Scalars['Boolean'];
  key: Scalars['String'];
  width: Scalars['Int'];
};

export type Commentary = Entity & {
  __typename?: 'Commentary';
  attachments?: Maybe<Array<AttachmentRef>>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
};

export type CommentaryFilterInput = {
  and?: InputMaybe<Array<CommentaryFilterInput>>;
  comment?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IdOperationFilterInput>;
  modifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CommentaryFilterInput>>;
};

export type CommentaryInput = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modifiedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ConcludeRegulatoryDocumentInput = {
  regulatoryDocumentId: Scalars['ID'];
};

export type ConcludeRegulatoryDocumentPayload = {
  __typename?: 'ConcludeRegulatoryDocumentPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type Convolute = Entity & NamedEntity & Node & {
  __typename?: 'Convolute';
  attachments?: Maybe<Array<AttachmentRef>>;
  convoluteType: ConvoluteType;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  gdprRule?: Maybe<GdprRule>;
  gdprRuleRef?: Maybe<EntityRefOfGdprRule>;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
};

export type ConvoluteSortInput = {
  convoluteType?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  gdprRuleRef?: InputMaybe<EntityRefOfGdprRuleSortInput>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export enum ConvoluteType {
  Regulation = 'REGULATION',
  RegulatoryDocument = 'REGULATORY_DOCUMENT',
  Requirement = 'REQUIREMENT',
  VehicleProject = 'VEHICLE_PROJECT'
}

export type CopyVersionMetadataUpdateFieldsInput = {
  copyAttachments?: Scalars['Boolean'];
  copyCategories?: Scalars['Boolean'];
  copyComprehensive?: Scalars['Boolean'];
  copyDriveVariants?: Scalars['Boolean'];
  copyKeywordAssignments?: Scalars['Boolean'];
  copyKeywords?: Scalars['Boolean'];
  copyModelYear?: Scalars['Boolean'];
  copyNewRegistration?: Scalars['Boolean'];
  copyNewTypes?: Scalars['Boolean'];
  copyPhaseIn?: Scalars['Boolean'];
  copyPhaseOut?: Scalars['Boolean'];
  copyRequirements?: Scalars['Boolean'];
  copySummary?: Scalars['Boolean'];
  copyTags?: Scalars['Boolean'];
  copyVehicleCategories?: Scalars['Boolean'];
};

export type Country = Entity & NamedEntity & Node & {
  __typename?: 'Country';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  translations?: Maybe<Array<TranslationObject>>;
};


export type CountryNameArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
};

export type CountrySortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type CreateActiveTypeMarketInput = {
  name: Scalars['String'];
};

export type CreateActiveTypeMarketPayload = {
  __typename?: 'CreateActiveTypeMarketPayload';
  activeTypeMarket?: Maybe<ActiveTypeMarket>;
};

export type CreateAnswerInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  text: Scalars['String'];
};

export type CreateApplicationInput = {
  description: Scalars['String'];
  imdsApplicationIri: Scalars['String'];
};

export type CreateAttachmentCategoryInput = {
  name: Scalars['String'];
};

export type CreateAttachmentCategoryPayload = {
  __typename?: 'CreateAttachmentCategoryPayload';
  attachmentCategory?: Maybe<AttachmentCategory>;
};

export type CreateBaselineInput = {
  generation: Scalars['String'];
  modelSeries: Scalars['String'];
  name: Scalars['String'];
  transferWorkflow: TransferWorkflowInput;
};

export type CreateBodyworkVariantInput = {
  name: Scalars['String'];
};

export type CreateBodyworkVariantPayload = {
  __typename?: 'CreateBodyworkVariantPayload';
  bodyworkVariant?: Maybe<BodyworkVariant>;
};

export type CreateCategoryInput = {
  name: Scalars['String'];
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type CreateCategoryPayload = {
  __typename?: 'CreateCategoryPayload';
  category?: Maybe<Category>;
};

export type CreateConvoluteInput = {
  convoluteType: ConvoluteType;
  gdprRuleRef?: InputMaybe<EntityRefOfGdprRuleInput>;
  name: Scalars['String'];
};

export type CreateConvolutePayload = {
  __typename?: 'CreateConvolutePayload';
  convolute?: Maybe<Convolute>;
};

export type CreateCountryInput = {
  name: Scalars['String'];
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type CreateCountryPayload = {
  __typename?: 'CreateCountryPayload';
  country?: Maybe<Country>;
};

export type CreateDocumentSourceInput = {
  name: Scalars['String'];
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type CreateDocumentSourcePayload = {
  __typename?: 'CreateDocumentSourcePayload';
  documentSource?: Maybe<DocumentSource>;
};

export type CreateDriveVariantInput = {
  name: Scalars['String'];
};

export type CreateDriveVariantPayload = {
  __typename?: 'CreateDriveVariantPayload';
  driveVariant?: Maybe<DriveVariant>;
};

export type CreateEngineVariantInput = {
  name: Scalars['String'];
};

export type CreateEngineVariantPayload = {
  __typename?: 'CreateEngineVariantPayload';
  engineVariant?: Maybe<EngineVariant>;
};

export type CreateGdprRuleInput = {
  anonymize: Scalars['Boolean'];
  deletionPeriod: Scalars['Int'];
  name: Scalars['String'];
};

export type CreateGdprRulePayload = {
  __typename?: 'CreateGdprRulePayload';
  gdprRule?: Maybe<GdprRule>;
};

export type CreateGearboxVariantInput = {
  name: Scalars['String'];
};

export type CreateGearboxVariantPayload = {
  __typename?: 'CreateGearboxVariantPayload';
  gearboxVariant?: Maybe<GearboxVariant>;
};

export type CreateGlobalAnnouncementInput = {
  activated: Scalars['Boolean'];
  content: Scalars['String'];
  emailNotification: Scalars['Boolean'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  roles: Array<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type CreateIcsCodeInput = {
  name: Scalars['String'];
};

export type CreateIcsCodePayload = {
  __typename?: 'CreateIcsCodePayload';
  icsCode?: Maybe<IcsCode>;
};

export type CreateKeywordInput = {
  approverRefs: Array<EntityRefOfUserInput>;
  inactiveReason?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  regulationClusterRefs: Array<EntityRefOfRegulationClusterInput>;
  sortPriority?: InputMaybe<Scalars['Int']>;
  successorRefs?: InputMaybe<Array<EntityRefOfKeywordInput>>;
  translations?: InputMaybe<Array<TranslationObjectInput>>;
  vexClusterRefs: Array<EntityRefOfVexClusterInput>;
  vkoRefs: Array<EntityRefOfVkoInput>;
};

export type CreateKeywordPayload = {
  __typename?: 'CreateKeywordPayload';
  keyword?: Maybe<Keyword>;
};

export type CreateLimitInput = {
  limits: Array<LimitInput>;
  traceParagraphId: Scalars['ID'];
  traceRegulationNumber: Scalars['String'];
};

export type CreateMarketInput = {
  childrenRefs: Array<EntityRefOfMarketInput>;
  countriesRef: Array<EntityRefOfCountryInput>;
  name: Scalars['String'];
  regulationNamingTemplates: Array<NamingTemplateInput>;
  regulatoryDocumentNamingTemplates: Array<NamingTemplateInput>;
  sortPriority?: InputMaybe<Scalars['Int']>;
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type CreateMarketPayload = {
  __typename?: 'CreateMarketPayload';
  market?: Maybe<Market>;
};

export type CreateMatkonParagraphAdditionalInformationInput = {
  contact: Scalars['String'];
  regulationNumber: Scalars['String'];
  traceParagraphId: Scalars['String'];
};

export type CreatePermissionGroupInput = {
  company: Scalars['String'];
  keywordRefs?: InputMaybe<Array<EntityRefOfKeywordInput>>;
  marketRefs?: InputMaybe<Array<EntityRefOfMarketInput>>;
  name: Scalars['String'];
  userRefs?: InputMaybe<Array<EntityRefOfUserInput>>;
};

export type CreatePogisDocumentInput = {
  associations?: InputMaybe<Array<Scalars['String']>>;
  dates: Array<PogisDateInput>;
  docStatus: Scalars['String'];
  editor: Scalars['String'];
  keywords: Array<Scalars['String']>;
  linkVersion?: InputMaybe<Scalars['String']>;
  markets: Array<Scalars['String']>;
  pogisId: Scalars['String'];
  regulationStatus: Scalars['String'];
  relatedDocuments?: InputMaybe<Array<Scalars['String']>>;
  shortInfo: Scalars['String'];
  standards?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateQuestionCategoryInput = {
  name: Scalars['String'];
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type CreateQuestionCategoryPayload = {
  __typename?: 'CreateQuestionCategoryPayload';
  questionCategory?: Maybe<QuestionCategory>;
};

export type CreateQuestionInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  categoryRef?: InputMaybe<EntityRefOfQuestionCategoryInput>;
  generationReference?: InputMaybe<Scalars['String']>;
  keywordRefs?: InputMaybe<Array<EntityRefOfKeywordInput>>;
  modelSeriesReference?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  roles?: InputMaybe<Array<Scalars['String']>>;
  targetCollection: Scalars['String'];
  targetRecords?: InputMaybe<Array<TargetCollectionInput>>;
  targetUserRefs: Array<EntityRefOfUserInput>;
};

export type CreateReferenceInput = {
  name: Scalars['String'];
  referenceTypes: Array<ReferenceType>;
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type CreateReferencePayload = {
  __typename?: 'CreateReferencePayload';
  reference?: Maybe<Reference>;
};

export type CreateRegulationClusterInput = {
  name: Scalars['String'];
};

export type CreateRegulationClusterPayload = {
  __typename?: 'CreateRegulationClusterPayload';
  regulationCluster?: Maybe<RegulationCluster>;
};

export type CreateRegulationInput = {
  deletionPeriod: Scalars['Int'];
  hidden: Scalars['Boolean'];
  icsCodeRefs?: InputMaybe<Array<EntityRefOfIcsCodeInput>>;
  isMachineRegulation?: Scalars['Boolean'];
  mainKeywordRefs: Array<EntityRefOfKeywordInput>;
  marketRefs: Array<EntityRefOfMarketInput>;
  name: Scalars['String'];
  regulationNumber: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
  standardPlusPcmsClusterRefs: Array<EntityRefOfStandardPlusPcmsClusterInput>;
  summary?: InputMaybe<Scalars['String']>;
  willBeAnonymized: Scalars['Boolean'];
};

export type CreateRegulatoryDocumentInput = {
  dateEffective?: InputMaybe<Scalars['Date']>;
  dateExpiration?: InputMaybe<Scalars['Date']>;
  deletionPeriod: Scalars['Int'];
  disassemblyStatus: RegulatoryDocumentDisassemblyStatus;
  documentReferences?: InputMaybe<Array<DocumentReferenceInput>>;
  documentSourceRef?: InputMaybe<EntityRefOfDocumentSourceInput>;
  finalVersionRef?: InputMaybe<EntityRefOfRegulatoryDocumentInput>;
  name: Scalars['String'];
  origin: Origin;
  pogisExists?: Scalars['Boolean'];
  pogisRefs: Array<EntityRefOfPogisDocumentInput>;
  predecessorRef?: InputMaybe<EntityRefOfRegulatoryDocumentInput>;
  predecessorRefs: Array<EntityRefOfRegulatoryDocumentInput>;
  regulationRef?: InputMaybe<EntityRefOfRegulationInput>;
  status: RegulatoryDocumentStatus;
  successorRef?: InputMaybe<EntityRefOfRegulatoryDocumentInput>;
  summary?: InputMaybe<Scalars['String']>;
  topicManagementSummary?: InputMaybe<TopicManagementSummaryInput>;
  willBeAnonymized: Scalars['Boolean'];
  workflow: WorkflowInput;
};

export type CreateRequirementInput = {
  activeTypeMarketRefs?: InputMaybe<Array<EntityRefOfActiveTypeMarketInput>>;
  approvalWorkFlow?: InputMaybe<ApprovalWorkFlowInput>;
  bodyworkVariantRefs?: InputMaybe<Array<EntityRefOfBodyworkVariantInput>>;
  category: RequirementCategory;
  definition?: InputMaybe<Scalars['String']>;
  deletionPeriod: Scalars['Int'];
  documentReferences?: InputMaybe<Array<DocumentReferenceInput>>;
  driveVariantRefs?: InputMaybe<Array<EntityRefOfDriveVariantInput>>;
  engineVariantRefs?: InputMaybe<Array<EntityRefOfEngineVariantInput>>;
  gearboxVariantRefs?: InputMaybe<Array<EntityRefOfGearboxVariantInput>>;
  keywordRefs?: InputMaybe<Array<EntityRefOfKeywordInput>>;
  marketRefs?: InputMaybe<Array<EntityRefOfMarketInput>>;
  name: Scalars['String'];
  parentRef?: InputMaybe<EntityRefOfRequirementInput>;
  requirementId?: InputMaybe<Scalars['String']>;
  status: RequirementStatus;
  successorRef?: InputMaybe<EntityRefOfRequirementInput>;
  systemLevelRefs?: InputMaybe<Array<EntityRefOfSystemLevelInput>>;
  tagRefs?: InputMaybe<Array<EntityRefOfTagInput>>;
  vehicleCategoryRefs?: InputMaybe<Array<EntityRefOfVehicleCategoryInput>>;
  version?: InputMaybe<Scalars['String']>;
  vexClusterRefs: Array<EntityRefOfVexClusterInput>;
  willBeAnonymized: Scalars['Boolean'];
};

export type CreateSimulationInput = {
  generationReference?: InputMaybe<Scalars['String']>;
  modelSeriesReference?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateStandardPlusPcmsClusterInput = {
  name: Scalars['String'];
};

export type CreateStandardPlusPcmsClusterPayload = {
  __typename?: 'CreateStandardPlusPcmsClusterPayload';
  standardPlusPcmsCluster?: Maybe<StandardPlusPcmsCluster>;
};

export type CreateSubscriptionInput = {
  keywordRefs?: InputMaybe<Array<EntityRefOfKeywordInput>>;
  marketRefs?: InputMaybe<Array<EntityRefOfMarketInput>>;
  name: Scalars['String'];
  notificationFormat: NotificationFormat;
  notificationFrequency: NotificationFrequency;
  notificationLang: NotificationLang;
  optOnlyForMainKeywords?: InputMaybe<Scalars['Boolean']>;
  pogisInterested?: InputMaybe<Scalars['Boolean']>;
  standardPlusPcmsClusterRefs?: InputMaybe<Array<EntityRefOfStandardPlusPcmsClusterInput>>;
};

export type CreateSystemLevelInput = {
  name: Scalars['String'];
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type CreateSystemLevelPayload = {
  __typename?: 'CreateSystemLevelPayload';
  systemLevel?: Maybe<SystemLevel>;
};

export type CreateTagInput = {
  name: Scalars['String'];
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type CreateTagPayload = {
  __typename?: 'CreateTagPayload';
  tag?: Maybe<Tag>;
};

export type CreateVehicleCategoryInput = {
  name: Scalars['String'];
};

export type CreateVehicleCategoryPayload = {
  __typename?: 'CreateVehicleCategoryPayload';
  vehicleCategory?: Maybe<VehicleCategory>;
};

export type CreateVehicleProjectInput = {
  activeTypeMarketRefs: Array<EntityRefOfActiveTypeMarketInput>;
  bodyworkVariantRefs: Array<EntityRefOfBodyworkVariantInput>;
  deletionPeriod: Scalars['Int'];
  derivative?: InputMaybe<Scalars['String']>;
  detVsi?: InputMaybe<Scalars['DateTime']>;
  driveVariantRefs: Array<EntityRefOfDriveVariantInput>;
  engineVariantRefs: Array<EntityRefOfEngineVariantInput>;
  eopVsi?: InputMaybe<Scalars['DateTime']>;
  euLegislation?: InputMaybe<Scalars['Boolean']>;
  gearboxVariantRefs: Array<EntityRefOfGearboxVariantInput>;
  generation: Scalars['String'];
  isElectro?: InputMaybe<Scalars['Boolean']>;
  isManuallyCreated: Scalars['Boolean'];
  marketRefs: Array<EntityRefOfMarketInput>;
  modelSeries: Scalars['String'];
  modelYear?: InputMaybe<Scalars['Int']>;
  p10Vsi?: InputMaybe<Scalars['DateTime']>;
  posEtVsi?: InputMaybe<Scalars['DateTime']>;
  posVsi?: InputMaybe<Scalars['DateTime']>;
  sopVsi: Scalars['DateTime'];
  sosVsi?: InputMaybe<Scalars['DateTime']>;
  sysgenVsi?: InputMaybe<Scalars['DateTime']>;
  typStartVsi?: InputMaybe<Scalars['DateTime']>;
  willBeAnonymized: Scalars['Boolean'];
  wvtaVsi?: InputMaybe<Scalars['DateTime']>;
};

export type CreateVexClusterInput = {
  approverRefs: Array<EntityRefOfUserInput>;
  name: Scalars['String'];
  userRefs: Array<EntityRefOfUserInput>;
};

export type CreateVexClusterPayload = {
  __typename?: 'CreateVexClusterPayload';
  vexCluster?: Maybe<VexCluster>;
};

export type CreateVkoInput = {
  marketRefs: Array<EntityRefOfMarketInput>;
  userRef: EntityRefOfUserInput;
};

export type CreateVkoPayload = {
  __typename?: 'CreateVkoPayload';
  vko?: Maybe<Vko>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type DeleteActiveTypeMarketInput = {
  id: Scalars['ID'];
};

export type DeleteActiveTypeMarketPayload = {
  __typename?: 'DeleteActiveTypeMarketPayload';
  activeTypeMarket?: Maybe<ActiveTypeMarket>;
};

export type DeleteAttachmentCategoryInput = {
  id: Scalars['ID'];
};

export type DeleteAttachmentCategoryPayload = {
  __typename?: 'DeleteAttachmentCategoryPayload';
  attachmentCategory?: Maybe<AttachmentCategory>;
};

export type DeleteBodyworkVariantInput = {
  id: Scalars['ID'];
};

export type DeleteBodyworkVariantPayload = {
  __typename?: 'DeleteBodyworkVariantPayload';
  bodyworkVariant?: Maybe<BodyworkVariant>;
};

export type DeleteCategoryInput = {
  id: Scalars['ID'];
};

export type DeleteCategoryPayload = {
  __typename?: 'DeleteCategoryPayload';
  category?: Maybe<Category>;
};

export type DeleteConvoluteInput = {
  id: Scalars['ID'];
};

export type DeleteConvolutePayload = {
  __typename?: 'DeleteConvolutePayload';
  convolute?: Maybe<Convolute>;
};

export type DeleteCountryInput = {
  id: Scalars['ID'];
};

export type DeleteCountryPayload = {
  __typename?: 'DeleteCountryPayload';
  country?: Maybe<Country>;
};

export type DeleteDocumentSourceInput = {
  id: Scalars['ID'];
};

export type DeleteDocumentSourcePayload = {
  __typename?: 'DeleteDocumentSourcePayload';
  documentSource?: Maybe<DocumentSource>;
};

export type DeleteDriveVariantInput = {
  id: Scalars['ID'];
};

export type DeleteDriveVariantPayload = {
  __typename?: 'DeleteDriveVariantPayload';
  driveVariant?: Maybe<DriveVariant>;
};

export type DeleteEngineVariantInput = {
  id: Scalars['ID'];
};

export type DeleteEngineVariantPayload = {
  __typename?: 'DeleteEngineVariantPayload';
  engineVariant?: Maybe<EngineVariant>;
};

export type DeleteGdprRuleInput = {
  id: Scalars['ID'];
};

export type DeleteGdprRulePayload = {
  __typename?: 'DeleteGdprRulePayload';
  gdprRule?: Maybe<GdprRule>;
};

export type DeleteGearboxVariantInput = {
  id: Scalars['ID'];
};

export type DeleteGearboxVariantPayload = {
  __typename?: 'DeleteGearboxVariantPayload';
  gearboxVariant?: Maybe<GearboxVariant>;
};

export type DeleteGlobalAnnouncementInput = {
  id: Scalars['ID'];
};

export type DeleteGlobalAnnouncementPayload = {
  __typename?: 'DeleteGlobalAnnouncementPayload';
  globalAnnouncement?: Maybe<GlobalAnnouncement>;
};

export type DeleteIcsCodeInput = {
  id: Scalars['ID'];
};

export type DeleteIcsCodePayload = {
  __typename?: 'DeleteIcsCodePayload';
  icsCode?: Maybe<IcsCode>;
};

export type DeleteKeywordInput = {
  id: Scalars['ID'];
};

export type DeleteKeywordPayload = {
  __typename?: 'DeleteKeywordPayload';
  keyword?: Maybe<Keyword>;
};

export type DeleteMarketInput = {
  id: Scalars['ID'];
};

export type DeleteMarketPayload = {
  __typename?: 'DeleteMarketPayload';
  market?: Maybe<Market>;
};

export type DeletePermissionGroupInput = {
  id: Scalars['ID'];
};

export type DeletePermissionGroupPayload = {
  __typename?: 'DeletePermissionGroupPayload';
  permissionGroup?: Maybe<PermissionGroup>;
};

export type DeleteQuestionCategoryInput = {
  id: Scalars['ID'];
};

export type DeleteQuestionCategoryPayload = {
  __typename?: 'DeleteQuestionCategoryPayload';
  questionCategory?: Maybe<QuestionCategory>;
};

export type DeleteReferenceInput = {
  id: Scalars['ID'];
};

export type DeleteReferencePayload = {
  __typename?: 'DeleteReferencePayload';
  reference?: Maybe<Reference>;
};

export type DeleteRegulationClusterInput = {
  id: Scalars['ID'];
};

export type DeleteRegulationClusterPayload = {
  __typename?: 'DeleteRegulationClusterPayload';
  regulationCluster?: Maybe<RegulationCluster>;
};

export type DeleteRegulationCommentaryInput = {
  commentId: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteRegulationCommentaryPayload = {
  __typename?: 'DeleteRegulationCommentaryPayload';
  regulation?: Maybe<Regulation>;
};

export type DeleteRegulationFaqInput = {
  faqId: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteRegulationFaqPayload = {
  __typename?: 'DeleteRegulationFaqPayload';
  regulation?: Maybe<Regulation>;
};

export type DeleteRegulationInput = {
  id: Scalars['ID'];
};

export type DeleteRegulationPayload = {
  __typename?: 'DeleteRegulationPayload';
  regulation?: Maybe<Regulation>;
};

export type DeleteRegulatoryDocumentCommentaryInput = {
  commentId: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteRegulatoryDocumentCommentaryPayload = {
  __typename?: 'DeleteRegulatoryDocumentCommentaryPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type DeleteRegulatoryDocumentFaqInput = {
  faqId: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteRegulatoryDocumentFaqPayload = {
  __typename?: 'DeleteRegulatoryDocumentFaqPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type DeleteRegulatoryDocumentInput = {
  id: Scalars['ID'];
};

export type DeleteRegulatoryDocumentParagraphCommentaryInput = {
  commentId: Scalars['ID'];
  paragraphId: Scalars['ID'];
  regulatoryDocumentId: Scalars['ID'];
};

export type DeleteRegulatoryDocumentParagraphCommentaryPayload = {
  __typename?: 'DeleteRegulatoryDocumentParagraphCommentaryPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type DeleteRegulatoryDocumentParagraphFaqInput = {
  faqId: Scalars['ID'];
  paragraphId: Scalars['ID'];
  regulatoryDocumentId: Scalars['ID'];
};

export type DeleteRegulatoryDocumentParagraphFaqPayload = {
  __typename?: 'DeleteRegulatoryDocumentParagraphFaqPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type DeleteRegulatoryDocumentPayload = {
  __typename?: 'DeleteRegulatoryDocumentPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type DeleteRequirementInput = {
  id: Scalars['ID'];
};

export type DeleteRequirementPayload = {
  __typename?: 'DeleteRequirementPayload';
  requirement?: Maybe<Requirement>;
};

export type DeleteSimulationInput = {
  id: Scalars['ID'];
};

export type DeleteSimulationPayload = {
  __typename?: 'DeleteSimulationPayload';
  simulation?: Maybe<Simulation>;
};

export type DeleteStandardPlusPcmsClusterInput = {
  id: Scalars['ID'];
};

export type DeleteStandardPlusPcmsClusterPayload = {
  __typename?: 'DeleteStandardPlusPcmsClusterPayload';
  standardPlusPcmsCluster?: Maybe<StandardPlusPcmsCluster>;
};

export type DeleteSubscriptionInput = {
  id: Scalars['ID'];
};

export type DeleteSubscriptionPayload = {
  __typename?: 'DeleteSubscriptionPayload';
  subscription?: Maybe<Subscription>;
};

export type DeleteSystemLevelInput = {
  id: Scalars['ID'];
};

export type DeleteSystemLevelPayload = {
  __typename?: 'DeleteSystemLevelPayload';
  systemLevel?: Maybe<SystemLevel>;
};

export type DeleteTagInput = {
  id: Scalars['ID'];
};

export type DeleteTagPayload = {
  __typename?: 'DeleteTagPayload';
  tag?: Maybe<Tag>;
};

export type DeleteVehicleCategoryInput = {
  id: Scalars['ID'];
};

export type DeleteVehicleCategoryPayload = {
  __typename?: 'DeleteVehicleCategoryPayload';
  vehicleCategory?: Maybe<VehicleCategory>;
};

export type DeleteVehicleProjectInput = {
  id: Scalars['ID'];
};

export type DeleteVehicleProjectPayload = {
  __typename?: 'DeleteVehicleProjectPayload';
  vehicleProjectMaster?: Maybe<VehicleProjectMaster>;
};

export type DeleteVexClusterInput = {
  id: Scalars['ID'];
};

export type DeleteVexClusterPayload = {
  __typename?: 'DeleteVexClusterPayload';
  vexCluster?: Maybe<VexCluster>;
};

export type DeleteVkoInput = {
  id: Scalars['ID'];
};

export type DeleteVkoPayload = {
  __typename?: 'DeleteVkoPayload';
  vko?: Maybe<Vko>;
};

export type DocumentReference = {
  __typename?: 'DocumentReference';
  documentReferenceGroup: ReferenceGroup;
  reference?: Maybe<Reference>;
  referenceDocumentType?: Maybe<Scalars['String']>;
  referencedByDocuments: Array<RegulatoryDocument>;
  regulatoryDocumentParagraphReferences?: Maybe<Array<EntityRefOfRegulatoryDocumentParagraph>>;
  requirementReferences: Array<Requirement>;
  selectAllRegulatoryDocuments: Scalars['Boolean'];
};

export type DocumentReferenceFilterInput = {
  and?: InputMaybe<Array<DocumentReferenceFilterInput>>;
  documentReferenceGroup?: InputMaybe<ReferenceGroupFilterInput>;
  or?: InputMaybe<Array<DocumentReferenceFilterInput>>;
  reference?: InputMaybe<EntityRefOfReferenceFilterInput>;
  referenceDocumentType?: InputMaybe<StringOperationFilterInput>;
  referencedByDocuments?: InputMaybe<ListFilterInputTypeOfEntityRefOfRegulatoryDocumentFilterInput>;
  regulatoryDocumentParagraphReferences?: InputMaybe<ListFilterInputTypeOfEntityRefOfRegulatoryDocumentParagraphFilterInput>;
  requirementReferences?: InputMaybe<ListFilterInputTypeOfEntityRefOfRequirementFilterInput>;
  selectAllRegulatoryDocuments?: InputMaybe<BooleanOperationFilterInput>;
};

export type DocumentReferenceInput = {
  documentReferenceGroup: ReferenceGroupInput;
  reference: EntityRefOfReferenceInput;
  referenceDocumentType?: InputMaybe<Scalars['String']>;
  referencedByDocuments?: InputMaybe<Array<EntityRefOfRegulatoryDocumentInput>>;
  regulatoryDocumentParagraphReferences?: InputMaybe<Array<EntityRefOfRegulatoryDocumentParagraphInput>>;
  requirementReferences?: InputMaybe<Array<EntityRefOfRequirementInput>>;
  selectAllRegulatoryDocuments: Scalars['Boolean'];
};

export type DocumentSource = Entity & NamedEntity & Node & {
  __typename?: 'DocumentSource';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  translations?: Maybe<Array<TranslationObject>>;
};


export type DocumentSourceNameArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
};

export enum DocumentStatus {
  NotSplit = 'NOT_SPLIT',
  SplittingError = 'SPLITTING_ERROR',
  SplittingFinished = 'SPLITTING_FINISHED',
  SplittingInProgress = 'SPLITTING_IN_PROGRESS'
}

export type DocumentStatusOperationFilterInput = {
  eq?: InputMaybe<DocumentStatus>;
  in?: InputMaybe<Array<DocumentStatus>>;
  neq?: InputMaybe<DocumentStatus>;
  nin?: InputMaybe<Array<DocumentStatus>>;
};

export type DoubletError = Error & {
  __typename?: 'DoubletError';
  message: Scalars['String'];
};

export type DoubletcheckRegulatoryDocumentFileInput = {
  file: Scalars['Upload'];
};

export type DoubletcheckRegulatoryDocumentFilePayload = {
  __typename?: 'DoubletcheckRegulatoryDocumentFilePayload';
  regulatoryDocument?: Maybe<Array<RegulatoryDocument>>;
};

export type DriveVariant = Entity & NamedEntity & Node & {
  __typename?: 'DriveVariant';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
};

export type DriveVariantSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export enum ELimitation {
  Components = 'Components',
  Mixtures = 'Mixtures',
  Substances = 'Substances'
}

export enum EOperator {
  Equal = 'Equal',
  Greater = 'Greater',
  GreaterOrEqual = 'GreaterOrEqual',
  Less = 'Less',
  LessOrEqual = 'LessOrEqual'
}

export enum EReferenceValue {
  Component = 'Component',
  HomogeneousMaterial = 'HomogeneousMaterial'
}

export type EngineVariant = Entity & NamedEntity & Node & {
  __typename?: 'EngineVariant';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
};

export type EngineVariantSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Entity = {
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
};

export enum EntityOperation {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type EntityOperationOperationFilterInput = {
  eq?: InputMaybe<EntityOperation>;
  in?: InputMaybe<Array<EntityOperation>>;
  neq?: InputMaybe<EntityOperation>;
  nin?: InputMaybe<Array<EntityOperation>>;
};

export type EntityRefOfActiveTypeMarketInput = {
  id: Scalars['ID'];
};

export type EntityRefOfBodyworkVariantInput = {
  id: Scalars['ID'];
};

export type EntityRefOfCategoryInput = {
  id: Scalars['ID'];
};

export type EntityRefOfCountryInput = {
  id: Scalars['ID'];
};

export type EntityRefOfDocumentSourceInput = {
  id: Scalars['ID'];
};

export type EntityRefOfDriveVariantInput = {
  id: Scalars['ID'];
};

export type EntityRefOfEngineVariantInput = {
  id: Scalars['ID'];
};

export type EntityRefOfGdprRule = {
  __typename?: 'EntityRefOfGdprRule';
  id: Scalars['ID'];
};

export type EntityRefOfGdprRuleInput = {
  id: Scalars['ID'];
};

export type EntityRefOfGdprRuleSortInput = {
  id?: InputMaybe<SortEnumType>;
};

export type EntityRefOfGearboxVariantInput = {
  id: Scalars['ID'];
};

export type EntityRefOfIcsCodeInput = {
  id: Scalars['ID'];
};

export type EntityRefOfKeyword = {
  __typename?: 'EntityRefOfKeyword';
  id: Scalars['ID'];
};

export type EntityRefOfKeywordFilterInput = {
  and?: InputMaybe<Array<EntityRefOfKeywordFilterInput>>;
  id?: InputMaybe<IdOperationFilterInput>;
  or?: InputMaybe<Array<EntityRefOfKeywordFilterInput>>;
};

export type EntityRefOfKeywordInput = {
  id: Scalars['ID'];
};

export type EntityRefOfMarket = {
  __typename?: 'EntityRefOfMarket';
  id: Scalars['ID'];
};

export type EntityRefOfMarketInput = {
  id: Scalars['ID'];
};

export type EntityRefOfPogisDocumentInput = {
  id: Scalars['ID'];
};

export type EntityRefOfQuestionCategoryInput = {
  id: Scalars['ID'];
};

export type EntityRefOfReferenceFilterInput = {
  and?: InputMaybe<Array<EntityRefOfReferenceFilterInput>>;
  id?: InputMaybe<IdOperationFilterInput>;
  or?: InputMaybe<Array<EntityRefOfReferenceFilterInput>>;
};

export type EntityRefOfReferenceInput = {
  id: Scalars['ID'];
};

export type EntityRefOfRegulationClusterInput = {
  id: Scalars['ID'];
};

export type EntityRefOfRegulationFilterInput = {
  and?: InputMaybe<Array<EntityRefOfRegulationFilterInput>>;
  id?: InputMaybe<IdOperationFilterInput>;
  or?: InputMaybe<Array<EntityRefOfRegulationFilterInput>>;
};

export type EntityRefOfRegulationInput = {
  id: Scalars['ID'];
};

export type EntityRefOfRegulatoryDocumentFilterInput = {
  and?: InputMaybe<Array<EntityRefOfRegulatoryDocumentFilterInput>>;
  id?: InputMaybe<IdOperationFilterInput>;
  or?: InputMaybe<Array<EntityRefOfRegulatoryDocumentFilterInput>>;
};

export type EntityRefOfRegulatoryDocumentInput = {
  id: Scalars['ID'];
};

export type EntityRefOfRegulatoryDocumentParagraph = {
  __typename?: 'EntityRefOfRegulatoryDocumentParagraph';
  id: Scalars['ID'];
};

export type EntityRefOfRegulatoryDocumentParagraphFilterInput = {
  and?: InputMaybe<Array<EntityRefOfRegulatoryDocumentParagraphFilterInput>>;
  id?: InputMaybe<IdOperationFilterInput>;
  or?: InputMaybe<Array<EntityRefOfRegulatoryDocumentParagraphFilterInput>>;
};

export type EntityRefOfRegulatoryDocumentParagraphInput = {
  id: Scalars['ID'];
};

export type EntityRefOfRequirement = {
  __typename?: 'EntityRefOfRequirement';
  id: Scalars['ID'];
};

export type EntityRefOfRequirementFilterInput = {
  and?: InputMaybe<Array<EntityRefOfRequirementFilterInput>>;
  id?: InputMaybe<IdOperationFilterInput>;
  or?: InputMaybe<Array<EntityRefOfRequirementFilterInput>>;
};

export type EntityRefOfRequirementInput = {
  id: Scalars['ID'];
};

export type EntityRefOfStandardPlusPcmsCluster = {
  __typename?: 'EntityRefOfStandardPlusPcmsCluster';
  id: Scalars['ID'];
};

export type EntityRefOfStandardPlusPcmsClusterInput = {
  id: Scalars['ID'];
};

export type EntityRefOfSystemLevel = {
  __typename?: 'EntityRefOfSystemLevel';
  id: Scalars['ID'];
};

export type EntityRefOfSystemLevelFilterInput = {
  and?: InputMaybe<Array<EntityRefOfSystemLevelFilterInput>>;
  id?: InputMaybe<IdOperationFilterInput>;
  or?: InputMaybe<Array<EntityRefOfSystemLevelFilterInput>>;
};

export type EntityRefOfSystemLevelInput = {
  id: Scalars['ID'];
};

export type EntityRefOfTagInput = {
  id: Scalars['ID'];
};

export type EntityRefOfUser = {
  __typename?: 'EntityRefOfUser';
  id: Scalars['ID'];
};

export type EntityRefOfUserFilterInput = {
  and?: InputMaybe<Array<EntityRefOfUserFilterInput>>;
  id?: InputMaybe<IdOperationFilterInput>;
  or?: InputMaybe<Array<EntityRefOfUserFilterInput>>;
};

export type EntityRefOfUserInput = {
  id: Scalars['ID'];
};

export type EntityRefOfVehicleCategoryInput = {
  id: Scalars['ID'];
};

export type EntityRefOfVehicleProject = {
  __typename?: 'EntityRefOfVehicleProject';
  id: Scalars['ID'];
};

export type EntityRefOfVexClusterFilterInput = {
  and?: InputMaybe<Array<EntityRefOfVexClusterFilterInput>>;
  id?: InputMaybe<IdOperationFilterInput>;
  or?: InputMaybe<Array<EntityRefOfVexClusterFilterInput>>;
};

export type EntityRefOfVexClusterInput = {
  id: Scalars['ID'];
};

export type EntityRefOfVkoInput = {
  id: Scalars['ID'];
};

export type Error = {
  message: Scalars['String'];
};

export type Faq = Entity & {
  __typename?: 'Faq';
  answer?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  question?: Maybe<Scalars['String']>;
};

export type FaqFilterInput = {
  and?: InputMaybe<Array<FaqFilterInput>>;
  answer?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IdOperationFilterInput>;
  modifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<FaqFilterInput>>;
  question?: InputMaybe<StringOperationFilterInput>;
};

export type FaqInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modifiedAt?: InputMaybe<Scalars['DateTime']>;
  question?: InputMaybe<Scalars['String']>;
};

export type Favorites = {
  __typename?: 'Favorites';
  paragraphs: Array<RegulatoryDocumentParagraph>;
  regulations: Array<Regulation>;
  regulatoryDocuments: Array<RegulatoryDocument>;
  requirements: Array<Requirement>;
};

export type FilterOption = {
  __typename?: 'FilterOption';
  name: Scalars['String'];
  optionKey: Scalars['String'];
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  ngt?: InputMaybe<Scalars['Float']>;
  ngte?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  nlt?: InputMaybe<Scalars['Float']>;
  nlte?: InputMaybe<Scalars['Float']>;
};

export type FullTextParagraphsResult = {
  __typename?: 'FullTextParagraphsResult';
  regulatoryDocumentsOtherData: Array<RegulatoryDocument>;
  regulatoryDocumentsSearchedPara: Array<RegulatoryDocument>;
};

export type FullTextPogisDocumentResult = {
  __typename?: 'FullTextPogisDocumentResult';
  pogisDocuments: Array<PogisDocument>;
};

export type FullTextRegulationResult = {
  __typename?: 'FullTextRegulationResult';
  regulations: Array<Regulation>;
};

export type FullTextRegulatoryDocumentResult = {
  __typename?: 'FullTextRegulatoryDocumentResult';
  regulatoryDocuments: Array<RegulatoryDocument>;
};

export type FullTextRequirementResult = {
  __typename?: 'FullTextRequirementResult';
  requirements: Array<Requirement>;
};

export type GdprRule = Entity & NamedEntity & Node & {
  __typename?: 'GdprRule';
  anonymize: Scalars['Boolean'];
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  deletionPeriod: Scalars['Int'];
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
};

export type GearboxVariant = Entity & NamedEntity & Node & {
  __typename?: 'GearboxVariant';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
};

export type GearboxVariantSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type GetApplicationResponse = {
  __typename?: 'GetApplicationResponse';
  nodes?: Maybe<Array<ApplicationNode>>;
  totalCount: Scalars['Int'];
};

export type GetHistoryOutput = Entity & {
  __typename?: 'GetHistoryOutput';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  totalCount: Scalars['Int'];
};

export type GetImdsApplicationResponse = {
  __typename?: 'GetImdsApplicationResponse';
  nodes?: Maybe<Array<ImdsApplication>>;
  totalCount: Scalars['Int'];
};

export type GetParagraphAdditionalInformationResponse = {
  __typename?: 'GetParagraphAdditionalInformationResponse';
  nodes?: Maybe<Array<ParagraphAdditionalInformation>>;
  totalCount: Scalars['Int'];
};

export type GetexRegulation = Entity & Node & {
  __typename?: 'GetexRegulation';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  regulationNumber: Scalars['String'];
  regulationTitle: Scalars['String'];
};

export type GetexRegulationFilterInput = {
  and?: InputMaybe<Array<GetexRegulationFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IdOperationFilterInput>;
  modifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<GetexRegulationFilterInput>>;
  regulationNumber?: InputMaybe<StringOperationFilterInput>;
  regulationTitle?: InputMaybe<StringOperationFilterInput>;
};

export type GetexRegulationSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  regulationNumber?: InputMaybe<SortEnumType>;
  regulationTitle?: InputMaybe<SortEnumType>;
};

export type GlobalAnnouncement = Entity & NamedEntity & Node & {
  __typename?: 'GlobalAnnouncement';
  activated: Scalars['Boolean'];
  attachments?: Maybe<Array<AttachmentRef>>;
  content: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  emailNotification: Scalars['Boolean'];
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  roles: Array<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
};

export type GlobalAnnouncementPayload = {
  __typename?: 'GlobalAnnouncementPayload';
  globalAnnouncement: GlobalAnnouncement;
};

export type IcsCode = Entity & NamedEntity & Node & {
  __typename?: 'IcsCode';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  icsCode?: Maybe<IcsCode>;
  id: Scalars['ID'];
  keyword?: Maybe<Keyword>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
};


export type IcsCodeIcsCodeArgs = {
  id: Scalars['String'];
};

export type IcsCodeSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type IdOperationFilterInput = {
  eq?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  neq?: InputMaybe<Scalars['ID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ImdsApplication = {
  __typename?: 'ImdsApplication';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['Int'];
  iri: Scalars['String'];
  isActive: Scalars['Boolean'];
  modifiedAt: Scalars['DateTime'];
  modifiedBy: Scalars['String'];
};

export type ImportRegulatoryDocumentParagraphInput = {
  categoryRefs: Array<EntityRefOfCategoryInput>;
  changeInfoType: ChangeInfoType;
  comments?: InputMaybe<Array<CommentaryInput>>;
  comprehensive?: InputMaybe<Scalars['Date']>;
  dateNewRegistration?: InputMaybe<Scalars['Date']>;
  dateNewTypes?: InputMaybe<Scalars['Date']>;
  driveVariantRefs: Array<EntityRefOfDriveVariantInput>;
  elements: Array<RegulatoryDocumentParagraphElementInput>;
  enumeration: Scalars['String'];
  faqs?: InputMaybe<Array<FaqInput>>;
  id?: InputMaybe<Scalars['ID']>;
  isFootnote: Scalars['Boolean'];
  keywordAssignments?: InputMaybe<Array<KeywordAssignmentInput>>;
  level: Scalars['Int'];
  modelYear?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  phaseIn?: InputMaybe<Array<PhaseDateInput>>;
  phaseOut?: InputMaybe<Array<PhaseDateInput>>;
  positionDB?: InputMaybe<Scalars['Int']>;
  reqIfSpecId?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  tagRefs: Array<EntityRefOfTagInput>;
  vehicleCategoryRefs: Array<EntityRefOfVehicleCategoryInput>;
};

export type ImportRegulatoryDocumentParagraphsInput = {
  paragraphs?: InputMaybe<Array<InputMaybe<ImportRegulatoryDocumentParagraphInput>>>;
  regulatoryDocumentId: Scalars['ID'];
};

export type ImportRegulatoryDocumentParagraphsPayload = {
  __typename?: 'ImportRegulatoryDocumentParagraphsPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type InfinityParagraphId = {
  __typename?: 'InfinityParagraphId';
  paragraphId: Scalars['String'];
  regDocId: Scalars['String'];
};

export type InfinityParagraphIdInput = {
  paragraphId: Scalars['String'];
  regDocId: Scalars['String'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type Keyword = Entity & NamedEntity & Node & {
  __typename?: 'Keyword';
  approvers: Array<User>;
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  inactiveReason?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  regulationClusters: Array<RegulationCluster>;
  sortPriority?: Maybe<Scalars['Int']>;
  successors: Array<Keyword>;
  translations?: Maybe<Array<TranslationObject>>;
  vexClusters: Array<VexCluster>;
  vkos: Array<User>;
};


export type KeywordNameArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
};

export type KeywordAssignment = {
  __typename?: 'KeywordAssignment';
  keyword: Keyword;
  vexClusterAssignments: Array<VexClusterAssignment>;
};

export type KeywordAssignmentFilterInput = {
  and?: InputMaybe<Array<KeywordAssignmentFilterInput>>;
  keyword?: InputMaybe<EntityRefOfKeywordFilterInput>;
  or?: InputMaybe<Array<KeywordAssignmentFilterInput>>;
  vexClusterAssignments?: InputMaybe<ListFilterInputTypeOfVexClusterAssignmentFilterInput>;
};

export type KeywordAssignmentInput = {
  keyword: EntityRefOfKeywordInput;
  vexClusterAssignments: Array<VexClusterAssignmentInput>;
};

export type KeywordSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inactiveReason?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  sortPriority?: InputMaybe<SortEnumType>;
};

export enum KeywordStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Finalized = 'FINALIZED',
  New = 'NEW',
  NoImpact = 'NO_IMPACT',
  NoRequirements = 'NO_REQUIREMENTS',
  RequirementsDerived = 'REQUIREMENTS_DERIVED'
}

export type KeywordStatusOperationFilterInput = {
  eq?: InputMaybe<KeywordStatus>;
  in?: InputMaybe<Array<KeywordStatus>>;
  neq?: InputMaybe<KeywordStatus>;
  nin?: InputMaybe<Array<KeywordStatus>>;
};

export type KeywordSuggestion = {
  __typename?: 'KeywordSuggestion';
  keyword: Keyword;
  suggestionNote: Scalars['String'];
};

export type KeywordSuggestionFilterInput = {
  and?: InputMaybe<Array<KeywordSuggestionFilterInput>>;
  keyword?: InputMaybe<EntityRefOfKeywordFilterInput>;
  or?: InputMaybe<Array<KeywordSuggestionFilterInput>>;
  suggestionNote?: InputMaybe<StringOperationFilterInput>;
};

export type KeywordSuggestionInput = {
  keyword: EntityRefOfKeywordInput;
  suggestionNote: Scalars['String'];
};

export type Limit = {
  __typename?: 'Limit';
  application?: Maybe<Application>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deadlineInternal: Scalars['String'];
  deadlineLaw: Scalars['String'];
  expirationDate: Scalars['String'];
  imdsAssessmentOverwritten: Scalars['Boolean'];
  iri: Scalars['String'];
  limitToSubstances: Array<Scalars['String']>;
  limitations: Array<Scalars['String']>;
  matConComplianceEvaluationOverwritten: Scalars['Boolean'];
  modifiedAt: Scalars['DateTime'];
  modifiedBy: Scalars['String'];
  operator: EOperator;
  referenceValue: EReferenceValue;
  unit: Scalars['String'];
  value: Scalars['Int'];
};

export type LimitInput = {
  applicationIri: Scalars['String'];
  attachment?: InputMaybe<AttachmentInput>;
  deadlineInternal: Scalars['DateTime'];
  deadlineLaw: Scalars['DateTime'];
  expirationDate: Scalars['DateTime'];
  imdsAssessmentOverwritten?: InputMaybe<Scalars['Boolean']>;
  iri: Scalars['String'];
  limitations: Array<ELimitation>;
  matConComplianceEvaluationOverwritten?: InputMaybe<Scalars['Boolean']>;
  operator: EOperator;
  referenceValue: EReferenceValue;
  unit: Scalars['String'];
  value: Scalars['Int'];
};

export type ListFilterInputTypeOfCommentaryFilterInput = {
  all?: InputMaybe<CommentaryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CommentaryFilterInput>;
  some?: InputMaybe<CommentaryFilterInput>;
};

export type ListFilterInputTypeOfDocumentReferenceFilterInput = {
  all?: InputMaybe<DocumentReferenceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentReferenceFilterInput>;
  some?: InputMaybe<DocumentReferenceFilterInput>;
};

export type ListFilterInputTypeOfEntityRefOfRegulatoryDocumentFilterInput = {
  all?: InputMaybe<EntityRefOfRegulatoryDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EntityRefOfRegulatoryDocumentFilterInput>;
  some?: InputMaybe<EntityRefOfRegulatoryDocumentFilterInput>;
};

export type ListFilterInputTypeOfEntityRefOfRegulatoryDocumentParagraphFilterInput = {
  all?: InputMaybe<EntityRefOfRegulatoryDocumentParagraphFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EntityRefOfRegulatoryDocumentParagraphFilterInput>;
  some?: InputMaybe<EntityRefOfRegulatoryDocumentParagraphFilterInput>;
};

export type ListFilterInputTypeOfEntityRefOfRequirementFilterInput = {
  all?: InputMaybe<EntityRefOfRequirementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EntityRefOfRequirementFilterInput>;
  some?: InputMaybe<EntityRefOfRequirementFilterInput>;
};

export type ListFilterInputTypeOfEntityRefOfSystemLevelFilterInput = {
  all?: InputMaybe<EntityRefOfSystemLevelFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EntityRefOfSystemLevelFilterInput>;
  some?: InputMaybe<EntityRefOfSystemLevelFilterInput>;
};

export type ListFilterInputTypeOfEntityRefOfUserFilterInput = {
  all?: InputMaybe<EntityRefOfUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EntityRefOfUserFilterInput>;
  some?: InputMaybe<EntityRefOfUserFilterInput>;
};

export type ListFilterInputTypeOfFaqFilterInput = {
  all?: InputMaybe<FaqFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FaqFilterInput>;
  some?: InputMaybe<FaqFilterInput>;
};

export type ListFilterInputTypeOfKeywordAssignmentFilterInput = {
  all?: InputMaybe<KeywordAssignmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<KeywordAssignmentFilterInput>;
  some?: InputMaybe<KeywordAssignmentFilterInput>;
};

export type ListFilterInputTypeOfKeywordSuggestionFilterInput = {
  all?: InputMaybe<KeywordSuggestionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<KeywordSuggestionFilterInput>;
  some?: InputMaybe<KeywordSuggestionFilterInput>;
};

export type ListFilterInputTypeOfPhaseDateFilterInput = {
  all?: InputMaybe<PhaseDateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PhaseDateFilterInput>;
  some?: InputMaybe<PhaseDateFilterInput>;
};

export type ListFilterInputTypeOfRegulatoryDocumentParagraphElementFilterInput = {
  all?: InputMaybe<RegulatoryDocumentParagraphElementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RegulatoryDocumentParagraphElementFilterInput>;
  some?: InputMaybe<RegulatoryDocumentParagraphElementFilterInput>;
};

export type ListFilterInputTypeOfRegulatoryDocumentParagraphFilterInput = {
  all?: InputMaybe<RegulatoryDocumentParagraphFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RegulatoryDocumentParagraphFilterInput>;
  some?: InputMaybe<RegulatoryDocumentParagraphFilterInput>;
};

export type ListFilterInputTypeOfTranslationObjectFilterInput = {
  all?: InputMaybe<TranslationObjectFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TranslationObjectFilterInput>;
  some?: InputMaybe<TranslationObjectFilterInput>;
};

export type ListFilterInputTypeOfVexClusterAssignmentFilterInput = {
  all?: InputMaybe<VexClusterAssignmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<VexClusterAssignmentFilterInput>;
  some?: InputMaybe<VexClusterAssignmentFilterInput>;
};

export type ListFloatOperationFilterInput = {
  all?: InputMaybe<FloatOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FloatOperationFilterInput>;
  some?: InputMaybe<FloatOperationFilterInput>;
};

export type MarkAsFinalAnswerPayload = {
  __typename?: 'MarkAsFinalAnswerPayload';
  succeeded: Scalars['Boolean'];
};

export type MarkAsReadGlobalAnnouncementInput = {
  id: Scalars['ID'];
};

export type MarkAsReadGlobalAnnouncementPayload = {
  __typename?: 'MarkAsReadGlobalAnnouncementPayload';
  boolean?: Maybe<Scalars['Boolean']>;
};

export type Market = Entity & NamedEntity & Node & {
  __typename?: 'Market';
  attachments?: Maybe<Array<AttachmentRef>>;
  childMarkets: Array<Market>;
  countries: Array<Country>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  regulationNamingTemplates: Array<NamingTemplate>;
  regulatoryDocumentNamingTemplates: Array<NamingTemplate>;
  sortPriority?: Maybe<Scalars['Int']>;
  translations?: Maybe<Array<TranslationObject>>;
};


export type MarketNameArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
};

export type MarketSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  sortPriority?: InputMaybe<SortEnumType>;
};

export type MatkonFileResult = {
  __typename?: 'MatkonFileResult';
  base64Content: Scalars['String'];
  contentType: Scalars['String'];
  fileName: Scalars['String'];
};

export type MergeReapprovalRegulatoryDocumentChangesInput = {
  finalRegulatoryDocumentId: Scalars['ID'];
  modifiedRegulatoryDocumentId: Scalars['ID'];
};

export type MergeReapprovalRegulatoryDocumentChangesPayload = {
  __typename?: 'MergeReapprovalRegulatoryDocumentChangesPayload';
  boolean?: Maybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addFavorite: User;
  addOrUpdateTableConfiguration: AddOrUpdateTableConfigurationPayload;
  addRegulationCommentary: Regulation;
  addRegulationFaq: Regulation;
  addRegulatoryDocumentCommentary: RegulatoryDocument;
  addRegulatoryDocumentFaq: RegulatoryDocument;
  addRegulatoryDocumentParagraphCommentary: AddRegulatoryDocumentParagraphCommentaryPayload;
  addRegulatoryDocumentParagraphFaq: AddRegulatoryDocumentParagraphFaqPayload;
  aggregateRegulation: Scalars['Boolean'];
  aggregateRegulations: Scalars['Boolean'];
  aggregateRequirement: Scalars['Boolean'];
  aggregateRequirements: Scalars['Boolean'];
  aggregateVehicleProjectGroup: Scalars['Boolean'];
  aggregateVehicleProjects: Scalars['String'];
  appendVersionMetadata: AppendVersionMetadataPayload;
  assignRegulatoryDocumentParagraphsRequirements: AssignRegulatoryDocumentParagraphsRequirementsPayload;
  assignRegulatoryDocumentParagraphsRequirementsDocumentCompare: AssignRegulatoryDocumentParagraphsRequirementsDocumentComparePayload;
  assignRegulatoryDocumentParagraphsTags: AssignRegulatoryDocumentParagraphsTagsPayload;
  assignReportConfiguration: AssignReportConfigurationPayload;
  assignVehicleProjectPermissions: AssignVehicleProjectPermissionsPayload;
  assignVehicleProjectRequirements: AssignVehicleProjectRequirementsPayload;
  baselineReqIfReexport: Scalars['Boolean'];
  checkVersionNameRegulatoryDocument: CheckVersionNameRegulatoryDocumentPayload;
  clearFieldForAllParagraphs: ClearFieldForAllParagraphsPayload;
  clearFieldForSelectedParagraphs: ClearFieldForSelectedParagraphsPayload;
  cloneAllParagraphsForRegulatoryDocument: CloneAllParagraphsForRegulatoryDocumentPayload;
  cloneRegulatoryDocument: RegulatoryDocumentPayload;
  concludeRegulatoryDocument: ConcludeRegulatoryDocumentPayload;
  correctionPhases: Scalars['Boolean'];
  createActiveTypeMarket: CreateActiveTypeMarketPayload;
  createAnswer: AnswerPayload;
  createAttachmentCategory: CreateAttachmentCategoryPayload;
  createBaseLineByModelAndSeries: BaselinePayload;
  createBodyworkVariant: CreateBodyworkVariantPayload;
  createCategory: CreateCategoryPayload;
  createConvolute: CreateConvolutePayload;
  createCountry: CreateCountryPayload;
  createDocumentSource: CreateDocumentSourcePayload;
  createDriveVariant: CreateDriveVariantPayload;
  createEngineVariant: CreateEngineVariantPayload;
  createGdprRule: CreateGdprRulePayload;
  createGearboxVariant: CreateGearboxVariantPayload;
  createGlobalAnnouncement: GlobalAnnouncementPayload;
  createIcsCode: CreateIcsCodePayload;
  createInterimRequirement: RegulatoryDocument;
  createKeyword: CreateKeywordPayload;
  createMarket: CreateMarketPayload;
  createMatkonApplication: ApplicationNode;
  createMatkonLimits: Array<Limit>;
  createMatkonParagraphAdditionalInformation: ParagraphAdditionalInformation;
  createPermissionGroup: PermissionGroupPayload;
  createPogisDocument: PogisDocumentPayload;
  createQuestion: QuestionPayload;
  createQuestionCategory: CreateQuestionCategoryPayload;
  createReference: CreateReferencePayload;
  createRegulation: RegulationPayload;
  createRegulationCluster: CreateRegulationClusterPayload;
  createRegulatoryDocument: RegulatoryDocumentPayload;
  createRequirement: RequirementPayload;
  createSimulation: SimulationPayload;
  createStandardPlusPcmsCluster: CreateStandardPlusPcmsClusterPayload;
  createSubscription: SubscriptionPayload;
  createSystemLevel: CreateSystemLevelPayload;
  createTag: CreateTagPayload;
  createVehicleCategory: CreateVehicleCategoryPayload;
  createVehicleProject: VehicleProjectPayload;
  createVexCluster: CreateVexClusterPayload;
  createVko: CreateVkoPayload;
  deleteActiveTypeMarket: DeleteActiveTypeMarketPayload;
  deleteAttachmentCategory: DeleteAttachmentCategoryPayload;
  deleteBodyworkVariant: DeleteBodyworkVariantPayload;
  deleteCategory: DeleteCategoryPayload;
  deleteConvolute: DeleteConvolutePayload;
  deleteCountry: DeleteCountryPayload;
  deleteDocumentSource: DeleteDocumentSourcePayload;
  deleteDriveVariant: DeleteDriveVariantPayload;
  deleteEngineVariant: DeleteEngineVariantPayload;
  deleteGdprRule: DeleteGdprRulePayload;
  deleteGearboxVariant: DeleteGearboxVariantPayload;
  deleteGlobalAnnouncement: DeleteGlobalAnnouncementPayload;
  deleteIcsCode: DeleteIcsCodePayload;
  deleteKeyword: DeleteKeywordPayload;
  deleteMarket: DeleteMarketPayload;
  deletePermissionGroup: DeletePermissionGroupPayload;
  deleteQuestionCategory: DeleteQuestionCategoryPayload;
  deleteReference: DeleteReferencePayload;
  deleteRegulation: DeleteRegulationPayload;
  deleteRegulationCluster: DeleteRegulationClusterPayload;
  deleteRegulationCommentary: DeleteRegulationCommentaryPayload;
  deleteRegulationFaq: DeleteRegulationFaqPayload;
  deleteRegulatoryDocument: DeleteRegulatoryDocumentPayload;
  deleteRegulatoryDocumentCommentary: DeleteRegulatoryDocumentCommentaryPayload;
  deleteRegulatoryDocumentFaq: DeleteRegulatoryDocumentFaqPayload;
  deleteRegulatoryDocumentParagraphCommentary: DeleteRegulatoryDocumentParagraphCommentaryPayload;
  deleteRegulatoryDocumentParagraphFaq: DeleteRegulatoryDocumentParagraphFaqPayload;
  deleteRequirement: DeleteRequirementPayload;
  deleteSimulation: DeleteSimulationPayload;
  deleteStandardPlusPcmsCluster: DeleteStandardPlusPcmsClusterPayload;
  deleteSubscription: DeleteSubscriptionPayload;
  deleteSystemLevel: DeleteSystemLevelPayload;
  deleteTag: DeleteTagPayload;
  deleteVehicleCategory: DeleteVehicleCategoryPayload;
  deleteVehicleProject: DeleteVehicleProjectPayload;
  deleteVexCluster: DeleteVexClusterPayload;
  deleteVko: DeleteVkoPayload;
  dismantleDocument: Scalars['Boolean'];
  doubletcheckRegulatoryDocumentFile: DoubletcheckRegulatoryDocumentFilePayload;
  importRegulatoryDocumentParagraphs: ImportRegulatoryDocumentParagraphsPayload;
  markAnswerAsFinal: MarkAsFinalAnswerPayload;
  markAsReadGlobalAnnouncement: MarkAsReadGlobalAnnouncementPayload;
  mergeReapprovalRegulatoryDocumentChanges: MergeReapprovalRegulatoryDocumentChangesPayload;
  migratePrecedessorRegDocs: Scalars['Boolean'];
  migrateRefs2RegDocs: Scalars['Boolean'];
  pathUploadRegulatoryDocumentAsset: Scalars['String'];
  reassignAllRegulatoryDocumentsForClonedRequirement: ReassignAllRegulatoryDocumentsForClonedRequirementPayload;
  removeAssignedVehicleProjectRequirements: RemoveAssignedVehicleProjectRequirementsPayload;
  removeFavorite: User;
  removeRegulatoryDocumentParagraphsRequirements: RemoveRegulatoryDocumentParagraphsRequirementsPayload;
  removeVehicleProjectPermissions: RemoveVehicleProjectPermissionsPayload;
  replaceVersionMetadata: ReplaceVersionMetadataPayload;
  syncNewVexClusters: SyncNewVexClustersPayload;
  unhideRegulation: Regulation;
  updateActiveTypeMarket: UpdateActiveTypeMarketPayload;
  updateAttachmentCategory: UpdateAttachmentCategoryPayload;
  updateBaseline: BaselinePayload;
  updateBodyworkVariant: UpdateBodyworkVariantPayload;
  updateCategory: UpdateCategoryPayload;
  updateConvolute: UpdateConvolutePayload;
  updateCountry: UpdateCountryPayload;
  updateDocumentSource: UpdateDocumentSourcePayload;
  updateDriveVariant: UpdateDriveVariantPayload;
  updateEngineVariant: UpdateEngineVariantPayload;
  updateGdprRule: UpdateGdprRulePayload;
  updateGearboxVariant: UpdateGearboxVariantPayload;
  updateGlobalAnnouncement: GlobalAnnouncementPayload;
  updateIcsCode: UpdateIcsCodePayload;
  updateKeyword: UpdateKeywordPayload;
  updateMarket: UpdateMarketPayload;
  updateParagraphAttachments: ParagraphAttachmentsPayload;
  updatePermissionGroup: PermissionGroupPayload;
  updatePogisDocument: PogisDocumentPayload;
  updatePogisDocumentAsset: PogisDocumentAttachmentsPayload;
  updatePogisDocumentSummary: PogisDocumentPayload;
  updateProjectRelevanceByRegulations: UpdateProjectRelevanceByRegulationsPayload;
  updateProjectRelevanceByRequirements: UpdateProjectRelevanceByRequirementsPayload;
  updateQuestionCategory: UpdateQuestionCategoryPayload;
  updateReference: UpdateReferencePayload;
  updateRegulation: RegulationPayload;
  updateRegulationAttachments: RegulationAttachmentsPayload;
  updateRegulationCluster: UpdateRegulationClusterPayload;
  updateRegulatoryDocument: RegulatoryDocumentPayload;
  updateRegulatoryDocumentAttachments: RegulatoryDocumentAttachmentsPayload;
  updateRegulatoryDocumentParagraph: UpdateRegulatoryDocumentParagraphPayload;
  updateRegulatoryDocumentParagraphBatch: UpdateRegulatoryDocumentParagraphBatchPayload;
  updateRegulatoryDocumentParagraphs: UpdateRegulatoryDocumentParagraphsPayload;
  updateRegulatoryDocumentStatus: UpdateRegulatoryDocumentStatusPayload;
  updateRegulatoryDocumentWorkflowStatus: RegulatoryDocument;
  updateRequirement: RequirementPayload;
  updateRequirementAttachments: RequirementAttachmentsPayload;
  updateRequirementsVersions: UpdateRequirementsVersionsPayload;
  updateSimulation: SimulationPayload;
  updateStandardPlusPcmsCluster: UpdateStandardPlusPcmsClusterPayload;
  updateSubscription: SubscriptionPayload;
  updateSystemLevel: UpdateSystemLevelPayload;
  updateTag: UpdateTagPayload;
  updateVehicleCategory: UpdateVehicleCategoryPayload;
  updateVehicleProject: VehicleProjectPayload;
  updateVexCluster: UpdateVexClusterPayload;
  updateVexClusterAssignmentBatch: UpdateVexClusterAssignmentBatchPayload;
  updateVko: UpdateVkoPayload;
  uploadRegulatoryDocumentAsset: RegulatoryDocumentAssetPayload;
  uploadRegulatoryDocumentWithAttachments: RegulatoryDocumentFilePayloadWithAttachments;
};


export type MutationAddFavoriteArgs = {
  id: Scalars['ID'];
};


export type MutationAddOrUpdateTableConfigurationArgs = {
  input: AddOrUpdateTableConfigurationInput;
};


export type MutationAddRegulationCommentaryArgs = {
  input: AddCommentaryInput;
};


export type MutationAddRegulationFaqArgs = {
  input: AddFaqInput;
};


export type MutationAddRegulatoryDocumentCommentaryArgs = {
  input: AddCommentaryInput;
};


export type MutationAddRegulatoryDocumentFaqArgs = {
  input: AddFaqInput;
};


export type MutationAddRegulatoryDocumentParagraphCommentaryArgs = {
  input: AddRegulatoryDocumentParagraphCommentaryInput;
};


export type MutationAddRegulatoryDocumentParagraphFaqArgs = {
  input: AddRegulatoryDocumentParagraphFaqInput;
};


export type MutationAggregateRegulationArgs = {
  regId: Scalars['ID'];
};


export type MutationAggregateRequirementArgs = {
  reqId: Scalars['ID'];
};


export type MutationAggregateVehicleProjectGroupArgs = {
  generation: Scalars['String'];
  modelSeries: Scalars['String'];
};


export type MutationAppendVersionMetadataArgs = {
  input: AppendVersionMetadataInput;
};


export type MutationAssignRegulatoryDocumentParagraphsRequirementsArgs = {
  input: AssignRegulatoryDocumentParagraphsRequirementsInput;
};


export type MutationAssignRegulatoryDocumentParagraphsRequirementsDocumentCompareArgs = {
  input: AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareInput;
};


export type MutationAssignRegulatoryDocumentParagraphsTagsArgs = {
  input: AssignRegulatoryDocumentParagraphsTagsInput;
};


export type MutationAssignReportConfigurationArgs = {
  input: AssignReportConfigurationInput;
};


export type MutationAssignVehicleProjectPermissionsArgs = {
  input: AssignVehicleProjectPermissionsInput;
};


export type MutationAssignVehicleProjectRequirementsArgs = {
  input: AssignVehicleProjectRequirementsInput;
};


export type MutationBaselineReqIfReexportArgs = {
  id: Scalars['ID'];
};


export type MutationCheckVersionNameRegulatoryDocumentArgs = {
  input: CheckVersionNameRegulatoryDocumentInput;
};


export type MutationClearFieldForAllParagraphsArgs = {
  input: ClearFieldForAllParagraphsInput;
};


export type MutationClearFieldForSelectedParagraphsArgs = {
  input: ClearFieldForSelectedParagraphsInput;
};


export type MutationCloneAllParagraphsForRegulatoryDocumentArgs = {
  input: CloneAllParagraphsForRegulatoryDocumentInput;
};


export type MutationCloneRegulatoryDocumentArgs = {
  input: CloneRegulatoryDocumentInput;
};


export type MutationConcludeRegulatoryDocumentArgs = {
  input: ConcludeRegulatoryDocumentInput;
};


export type MutationCreateActiveTypeMarketArgs = {
  input: CreateActiveTypeMarketInput;
};


export type MutationCreateAnswerArgs = {
  input: CreateAnswerInput;
  questionId: Scalars['ID'];
};


export type MutationCreateAttachmentCategoryArgs = {
  input: CreateAttachmentCategoryInput;
};


export type MutationCreateBaseLineByModelAndSeriesArgs = {
  input: CreateBaselineInput;
};


export type MutationCreateBodyworkVariantArgs = {
  input: CreateBodyworkVariantInput;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateConvoluteArgs = {
  input: CreateConvoluteInput;
};


export type MutationCreateCountryArgs = {
  input: CreateCountryInput;
};


export type MutationCreateDocumentSourceArgs = {
  input: CreateDocumentSourceInput;
};


export type MutationCreateDriveVariantArgs = {
  input: CreateDriveVariantInput;
};


export type MutationCreateEngineVariantArgs = {
  input: CreateEngineVariantInput;
};


export type MutationCreateGdprRuleArgs = {
  input: CreateGdprRuleInput;
};


export type MutationCreateGearboxVariantArgs = {
  input: CreateGearboxVariantInput;
};


export type MutationCreateGlobalAnnouncementArgs = {
  input: CreateGlobalAnnouncementInput;
};


export type MutationCreateIcsCodeArgs = {
  input: CreateIcsCodeInput;
};


export type MutationCreateInterimRequirementArgs = {
  boolCreateInterimRequirementForce?: InputMaybe<Scalars['Boolean']>;
  regulatoryDocumentId: Scalars['ID'];
};


export type MutationCreateKeywordArgs = {
  input: CreateKeywordInput;
};


export type MutationCreateMarketArgs = {
  input: CreateMarketInput;
};


export type MutationCreateMatkonApplicationArgs = {
  input: CreateApplicationInput;
};


export type MutationCreateMatkonLimitsArgs = {
  input: CreateLimitInput;
};


export type MutationCreateMatkonParagraphAdditionalInformationArgs = {
  input: CreateMatkonParagraphAdditionalInformationInput;
};


export type MutationCreatePermissionGroupArgs = {
  input: CreatePermissionGroupInput;
};


export type MutationCreatePogisDocumentArgs = {
  input: CreatePogisDocumentInput;
};


export type MutationCreateQuestionArgs = {
  input: CreateQuestionInput;
};


export type MutationCreateQuestionCategoryArgs = {
  input: CreateQuestionCategoryInput;
};


export type MutationCreateReferenceArgs = {
  input: CreateReferenceInput;
};


export type MutationCreateRegulationArgs = {
  input: CreateRegulationInput;
};


export type MutationCreateRegulationClusterArgs = {
  input: CreateRegulationClusterInput;
};


export type MutationCreateRegulatoryDocumentArgs = {
  input: CreateRegulatoryDocumentInput;
  reapprovingVKO?: InputMaybe<EntityRefOfUserInput>;
};


export type MutationCreateRequirementArgs = {
  input: CreateRequirementInput;
};


export type MutationCreateSimulationArgs = {
  input: CreateSimulationInput;
};


export type MutationCreateStandardPlusPcmsClusterArgs = {
  input: CreateStandardPlusPcmsClusterInput;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateSystemLevelArgs = {
  input: CreateSystemLevelInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateVehicleCategoryArgs = {
  input: CreateVehicleCategoryInput;
};


export type MutationCreateVehicleProjectArgs = {
  input: CreateVehicleProjectInput;
};


export type MutationCreateVexClusterArgs = {
  input: CreateVexClusterInput;
};


export type MutationCreateVkoArgs = {
  input: CreateVkoInput;
};


export type MutationDeleteActiveTypeMarketArgs = {
  input: DeleteActiveTypeMarketInput;
};


export type MutationDeleteAttachmentCategoryArgs = {
  input: DeleteAttachmentCategoryInput;
};


export type MutationDeleteBodyworkVariantArgs = {
  input: DeleteBodyworkVariantInput;
};


export type MutationDeleteCategoryArgs = {
  input: DeleteCategoryInput;
};


export type MutationDeleteConvoluteArgs = {
  input: DeleteConvoluteInput;
};


export type MutationDeleteCountryArgs = {
  input: DeleteCountryInput;
};


export type MutationDeleteDocumentSourceArgs = {
  input: DeleteDocumentSourceInput;
};


export type MutationDeleteDriveVariantArgs = {
  input: DeleteDriveVariantInput;
};


export type MutationDeleteEngineVariantArgs = {
  input: DeleteEngineVariantInput;
};


export type MutationDeleteGdprRuleArgs = {
  input: DeleteGdprRuleInput;
};


export type MutationDeleteGearboxVariantArgs = {
  input: DeleteGearboxVariantInput;
};


export type MutationDeleteGlobalAnnouncementArgs = {
  input: DeleteGlobalAnnouncementInput;
};


export type MutationDeleteIcsCodeArgs = {
  input: DeleteIcsCodeInput;
};


export type MutationDeleteKeywordArgs = {
  input: DeleteKeywordInput;
};


export type MutationDeleteMarketArgs = {
  input: DeleteMarketInput;
};


export type MutationDeletePermissionGroupArgs = {
  input: DeletePermissionGroupInput;
};


export type MutationDeleteQuestionCategoryArgs = {
  input: DeleteQuestionCategoryInput;
};


export type MutationDeleteReferenceArgs = {
  input: DeleteReferenceInput;
};


export type MutationDeleteRegulationArgs = {
  input: DeleteRegulationInput;
};


export type MutationDeleteRegulationClusterArgs = {
  input: DeleteRegulationClusterInput;
};


export type MutationDeleteRegulationCommentaryArgs = {
  input: DeleteRegulationCommentaryInput;
};


export type MutationDeleteRegulationFaqArgs = {
  input: DeleteRegulationFaqInput;
};


export type MutationDeleteRegulatoryDocumentArgs = {
  input: DeleteRegulatoryDocumentInput;
};


export type MutationDeleteRegulatoryDocumentCommentaryArgs = {
  input: DeleteRegulatoryDocumentCommentaryInput;
};


export type MutationDeleteRegulatoryDocumentFaqArgs = {
  input: DeleteRegulatoryDocumentFaqInput;
};


export type MutationDeleteRegulatoryDocumentParagraphCommentaryArgs = {
  input: DeleteRegulatoryDocumentParagraphCommentaryInput;
};


export type MutationDeleteRegulatoryDocumentParagraphFaqArgs = {
  input: DeleteRegulatoryDocumentParagraphFaqInput;
};


export type MutationDeleteRequirementArgs = {
  input: DeleteRequirementInput;
};


export type MutationDeleteSimulationArgs = {
  input: DeleteSimulationInput;
};


export type MutationDeleteStandardPlusPcmsClusterArgs = {
  input: DeleteStandardPlusPcmsClusterInput;
};


export type MutationDeleteSubscriptionArgs = {
  input: DeleteSubscriptionInput;
};


export type MutationDeleteSystemLevelArgs = {
  input: DeleteSystemLevelInput;
};


export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};


export type MutationDeleteVehicleCategoryArgs = {
  input: DeleteVehicleCategoryInput;
};


export type MutationDeleteVehicleProjectArgs = {
  input: DeleteVehicleProjectInput;
};


export type MutationDeleteVexClusterArgs = {
  input: DeleteVexClusterInput;
};


export type MutationDeleteVkoArgs = {
  input: DeleteVkoInput;
};


export type MutationDismantleDocumentArgs = {
  fastTrack: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationDoubletcheckRegulatoryDocumentFileArgs = {
  input: DoubletcheckRegulatoryDocumentFileInput;
};


export type MutationImportRegulatoryDocumentParagraphsArgs = {
  input: ImportRegulatoryDocumentParagraphsInput;
};


export type MutationMarkAnswerAsFinalArgs = {
  answerId: Scalars['ID'];
  questionId: Scalars['ID'];
};


export type MutationMarkAsReadGlobalAnnouncementArgs = {
  input: MarkAsReadGlobalAnnouncementInput;
};


export type MutationMergeReapprovalRegulatoryDocumentChangesArgs = {
  input: MergeReapprovalRegulatoryDocumentChangesInput;
};


export type MutationPathUploadRegulatoryDocumentAssetArgs = {
  assetId: Scalars['String'];
  regulatoryDocumentId: Scalars['ID'];
};


export type MutationReassignAllRegulatoryDocumentsForClonedRequirementArgs = {
  input: ReassignAllRegulatoryDocumentsForClonedRequirementInput;
};


export type MutationRemoveAssignedVehicleProjectRequirementsArgs = {
  input: RemoveAssignedVehicleProjectRequirementsInput;
};


export type MutationRemoveFavoriteArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveRegulatoryDocumentParagraphsRequirementsArgs = {
  input: RemoveRegulatoryDocumentParagraphsRequirementsInput;
};


export type MutationRemoveVehicleProjectPermissionsArgs = {
  input: RemoveVehicleProjectPermissionsInput;
};


export type MutationReplaceVersionMetadataArgs = {
  input: ReplaceVersionMetadataInput;
};


export type MutationSyncNewVexClustersArgs = {
  input: SyncNewVexClustersInput;
};


export type MutationUnhideRegulationArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateActiveTypeMarketArgs = {
  input: UpdateActiveTypeMarketInput;
};


export type MutationUpdateAttachmentCategoryArgs = {
  input: UpdateAttachmentCategoryInput;
};


export type MutationUpdateBaselineArgs = {
  input: UpdateBaselineInput;
};


export type MutationUpdateBodyworkVariantArgs = {
  input: UpdateBodyworkVariantInput;
};


export type MutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


export type MutationUpdateConvoluteArgs = {
  input: UpdateConvoluteInput;
};


export type MutationUpdateCountryArgs = {
  input: UpdateCountryInput;
};


export type MutationUpdateDocumentSourceArgs = {
  input: UpdateDocumentSourceInput;
};


export type MutationUpdateDriveVariantArgs = {
  input: UpdateDriveVariantInput;
};


export type MutationUpdateEngineVariantArgs = {
  input: UpdateEngineVariantInput;
};


export type MutationUpdateGdprRuleArgs = {
  input: UpdateGdprRuleInput;
};


export type MutationUpdateGearboxVariantArgs = {
  input: UpdateGearboxVariantInput;
};


export type MutationUpdateGlobalAnnouncementArgs = {
  input: UpdateGlobalAnnouncementInput;
};


export type MutationUpdateIcsCodeArgs = {
  input: UpdateIcsCodeInput;
};


export type MutationUpdateKeywordArgs = {
  input: UpdateKeywordInput;
};


export type MutationUpdateMarketArgs = {
  input: UpdateMarketInput;
};


export type MutationUpdateParagraphAttachmentsArgs = {
  input: UpdateParagraphAttachmentsInput;
};


export type MutationUpdatePermissionGroupArgs = {
  input: UpdatePermissionGroupInput;
};


export type MutationUpdatePogisDocumentArgs = {
  input: UpdatePogisDocumentInput;
};


export type MutationUpdatePogisDocumentAssetArgs = {
  input: UpdatePogisDocumentAssetInput;
};


export type MutationUpdatePogisDocumentSummaryArgs = {
  pogisDocumentId: Scalars['ID'];
  summary: Scalars['String'];
};


export type MutationUpdateProjectRelevanceByRegulationsArgs = {
  input: UpdateProjectRelevanceByRegulationsInput;
};


export type MutationUpdateProjectRelevanceByRequirementsArgs = {
  input: UpdateProjectRelevanceByRequirementsInput;
};


export type MutationUpdateQuestionCategoryArgs = {
  input: UpdateQuestionCategoryInput;
};


export type MutationUpdateReferenceArgs = {
  input: UpdateReferenceInput;
};


export type MutationUpdateRegulationArgs = {
  input: UpdateRegulationInput;
};


export type MutationUpdateRegulationAttachmentsArgs = {
  input: UpdateRegulationAttachmentsInput;
};


export type MutationUpdateRegulationClusterArgs = {
  input: UpdateRegulationClusterInput;
};


export type MutationUpdateRegulatoryDocumentArgs = {
  clearingVKOs?: InputMaybe<Array<EntityRefOfUserInput>>;
  input: UpdateRegulatoryDocumentInput;
  reapprovingVKO?: InputMaybe<EntityRefOfUserInput>;
};


export type MutationUpdateRegulatoryDocumentAttachmentsArgs = {
  input: UpdateRegulatoryDocumentAttachmentsInput;
};


export type MutationUpdateRegulatoryDocumentParagraphArgs = {
  input: UpdateRegulatoryDocumentParagraphInput;
};


export type MutationUpdateRegulatoryDocumentParagraphBatchArgs = {
  input: UpdateRegulatoryDocumentParagraphBatchInput;
};


export type MutationUpdateRegulatoryDocumentParagraphsArgs = {
  input: UpdateRegulatoryDocumentParagraphsInput;
};


export type MutationUpdateRegulatoryDocumentStatusArgs = {
  input: UpdateRegulatoryDocumentStatusInput;
};


export type MutationUpdateRegulatoryDocumentWorkflowStatusArgs = {
  regulatoryDocumentId: Scalars['ID'];
  workflowStatus: WorkflowStatus;
};


export type MutationUpdateRequirementArgs = {
  input: UpdateRequirementInput;
};


export type MutationUpdateRequirementAttachmentsArgs = {
  input: UpdateRequirementAttachmentsInput;
};


export type MutationUpdateRequirementsVersionsArgs = {
  input: UpdateRequirementsVersionsInput;
};


export type MutationUpdateSimulationArgs = {
  input: UpdateSimulationInput;
};


export type MutationUpdateStandardPlusPcmsClusterArgs = {
  input: UpdateStandardPlusPcmsClusterInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateSystemLevelArgs = {
  input: UpdateSystemLevelInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateVehicleCategoryArgs = {
  input: UpdateVehicleCategoryInput;
};


export type MutationUpdateVehicleProjectArgs = {
  input: UpdateVehicleProjectInput;
};


export type MutationUpdateVexClusterArgs = {
  input: UpdateVexClusterInput;
};


export type MutationUpdateVexClusterAssignmentBatchArgs = {
  input: UpdateVexClusterAssignmentBatchInput;
};


export type MutationUpdateVkoArgs = {
  input: UpdateVkoInput;
};


export type MutationUploadRegulatoryDocumentAssetArgs = {
  input: UploadRegulatoryDocumentAssetInput;
};


export type MutationUploadRegulatoryDocumentWithAttachmentsArgs = {
  input: UploadRegulatoryDocumentWithAttachmentsInput;
};

export type NamedEntity = {
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
};

export type NamingTemplate = {
  __typename?: 'NamingTemplate';
  description: Scalars['String'];
  template: Scalars['String'];
};

export type NamingTemplateInput = {
  description: Scalars['String'];
  template: Scalars['String'];
};

export type NextArgsAssignedEntityInput = {
  generation: Scalars['String'];
  modelSeries: Scalars['String'];
  nextArgs: NextArgsInput;
};

export type NextArgsBaselineRequirmentsInput = {
  baselineId: Scalars['String'];
  nextArgs: NextArgsInput;
};

export type NextArgsInput = {
  preFilteredIds: Array<Scalars['String']>;
};

export type NextArgsParagraphsInput = {
  preFilteredParagraphIds: Array<InfinityParagraphIdInput>;
};

/** The node interface is implemented by entities that have a global unique identifier. */
export type Node = {
  id: Scalars['ID'];
};

export enum NotificationFormat {
  Email = 'EMAIL',
  None = 'NONE'
}

export enum NotificationFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY'
}

export enum NotificationLang {
  En = 'EN',
  Std = 'STD'
}

export type NullableOfTextPositionOperationFilterInput = {
  eq?: InputMaybe<TextPosition>;
  in?: InputMaybe<Array<InputMaybe<TextPosition>>>;
  neq?: InputMaybe<TextPosition>;
  nin?: InputMaybe<Array<InputMaybe<TextPosition>>>;
};

export enum Origin {
  External = 'EXTERNAL',
  Import = 'IMPORT',
  Internal = 'INTERNAL'
}

export type OriginOperationFilterInput = {
  eq?: InputMaybe<Origin>;
  in?: InputMaybe<Array<Origin>>;
  neq?: InputMaybe<Origin>;
  nin?: InputMaybe<Array<Origin>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type ParagraphAdditionalInformation = {
  __typename?: 'ParagraphAdditionalInformation';
  contact: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  iri: Scalars['String'];
  isWorstCased: Scalars['Boolean'];
  limits: Array<Limit>;
  modifiedAt: Scalars['DateTime'];
  modifiedBy: Scalars['String'];
  regulationNumber: Scalars['String'];
  traceParagraphId: Scalars['String'];
};

export type ParagraphAttachmentsPayload = {
  __typename?: 'ParagraphAttachmentsPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export enum ParagraphElementType {
  Html = 'HTML',
  HtmlTable = 'HTML_TABLE',
  Image = 'IMAGE',
  NewLine = 'NEW_LINE',
  Table = 'TABLE',
  Text = 'TEXT'
}

export type ParagraphElementTypeOperationFilterInput = {
  eq?: InputMaybe<ParagraphElementType>;
  in?: InputMaybe<Array<ParagraphElementType>>;
  neq?: InputMaybe<ParagraphElementType>;
  nin?: InputMaybe<Array<ParagraphElementType>>;
};

export type ParagraphFilterOptions = {
  __typename?: 'ParagraphFilterOptions';
  categoryOptions: Array<FilterOption>;
  driveVariantOptions: Array<FilterOption>;
  keywordOptions: Array<FilterOption>;
  mainKeywordOptions: Array<FilterOption>;
  marketOptions: Array<FilterOption>;
  regulationOptions: Array<FilterOption>;
  regulatoryDocumentOptions: Array<FilterOption>;
  vehicleCategoryOptions: Array<FilterOption>;
};

export type ParagraphInfinityResults = {
  __typename?: 'ParagraphInfinityResults';
  filteredParagraphsIds: Array<InfinityParagraphId>;
  paragraphFilterOptions: ParagraphFilterOptions;
  paragraphsBatch: Array<RegulatoryDocumentParagraph>;
};

export type ParagraphUpdateInput = {
  paragraphId: Scalars['ID'];
  update: UpdateRegulatoryDocumentParagraphUpdateInput;
};

export type PermissionGroup = Entity & NamedEntity & Node & {
  __typename?: 'PermissionGroup';
  attachments?: Maybe<Array<AttachmentRef>>;
  company?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  keywords: Array<Keyword>;
  markets: Array<Market>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  users: Array<User>;
};

export type PermissionGroupPayload = {
  __typename?: 'PermissionGroupPayload';
  permissionGroup: PermissionGroup;
};

export type PhaseDate = {
  __typename?: 'PhaseDate';
  date?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
};

export type PhaseDateFilterInput = {
  and?: InputMaybe<Array<PhaseDateFilterInput>>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PhaseDateFilterInput>>;
  status?: InputMaybe<StringOperationFilterInput>;
};

export type PhaseDateInput = {
  date?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
};

export type PogisDate = {
  __typename?: 'PogisDate';
  date: Scalars['DateTime'];
  dateType: Scalars['String'];
};

export type PogisDateInput = {
  date: Scalars['DateTime'];
  dateType: Scalars['String'];
};

export type PogisDocument = Entity & NamedEntity & Node & {
  __typename?: 'PogisDocument';
  associations?: Maybe<Array<Scalars['String']>>;
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  dates: Array<PogisDate>;
  docStatus: Scalars['String'];
  editor: Scalars['String'];
  hiddenSearchData?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  keywords: Array<Scalars['String']>;
  linkVersion?: Maybe<Scalars['String']>;
  markets: Array<Scalars['String']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  pogisAttachments?: Maybe<Array<AttachmentRef>>;
  pogisId: Scalars['String'];
  regulationStatus: Scalars['String'];
  relatedDocuments?: Maybe<Array<Scalars['String']>>;
  shortInfo: Scalars['String'];
  standards?: Maybe<Array<Scalars['String']>>;
};

export type PogisDocumentAttachmentsPayload = {
  __typename?: 'PogisDocumentAttachmentsPayload';
  pogisDocumentAttachments?: Maybe<AttachmentRef>;
};

export type PogisDocumentPayload = {
  __typename?: 'PogisDocumentPayload';
  pogisDocument: PogisDocument;
};

export type PogisDocumentsInfinityResults = {
  __typename?: 'PogisDocumentsInfinityResults';
  pogisDocumentsBatch: Array<PogisDocument>;
  pogisFilterOptions: PogisFilterOptions;
  pogisIds: Array<Scalars['String']>;
};

export type PogisFilterOptions = {
  __typename?: 'PogisFilterOptions';
  editorOptions: Array<FilterOption>;
  keywordOptions: Array<FilterOption>;
  marketOptions: Array<FilterOption>;
  myOptions: Array<Scalars['String']>;
  pogisIdOptions: Array<Scalars['String']>;
  regStatusOptions: Array<FilterOption>;
  standardOptions: Array<FilterOption>;
};

export type Query = {
  __typename?: 'Query';
  activeKeywords: Array<Keyword>;
  activeTypeMarket?: Maybe<ActiveTypeMarket>;
  activeTypeMarkets?: Maybe<Array<ActiveTypeMarket>>;
  allGetexRegulations: Array<GetexRegulation>;
  allGlobalAnnouncements: Array<GlobalAnnouncement>;
  allKeywordVexExportConfigUsers: Array<User>;
  allPermissionGroups: Array<PermissionGroup>;
  allSubscriptions: Array<Subscription>;
  attachmentCategories?: Maybe<Array<AttachmentCategory>>;
  attachmentCategory?: Maybe<AttachmentCategory>;
  auditLogs?: Maybe<AuditLogsConnection>;
  baselineById?: Maybe<Baseline>;
  baselineRequirementsNext: Array<AssignedRequirement>;
  baselineRequirementsQuery: AssignedRequirementsInfinityResults;
  bodyworkVariant?: Maybe<BodyworkVariant>;
  bodyworkVariants?: Maybe<Array<BodyworkVariant>>;
  canRegulationBeHidden: Scalars['Boolean'];
  categories?: Maybe<Array<Category>>;
  category?: Maybe<Category>;
  convolute?: Maybe<Convolute>;
  convolutes?: Maybe<Array<Convolute>>;
  countries?: Maybe<Array<Country>>;
  country?: Maybe<Country>;
  documentSource?: Maybe<DocumentSource>;
  documentSources?: Maybe<Array<DocumentSource>>;
  driveVariant?: Maybe<DriveVariant>;
  driveVariants?: Maybe<Array<DriveVariant>>;
  engineVariant?: Maybe<EngineVariant>;
  engineVariants?: Maybe<Array<EngineVariant>>;
  evaluateRegulations: Array<Regulation>;
  evaluateRegulatoryDocumentParagraphs: Array<RegulatoryDocumentParagraph>;
  evaluateRegulatoryDocuments: Array<RegulatoryDocument>;
  evaluateRequirements: Array<Requirement>;
  evaluateVehicleProjects: Array<VehicleProject>;
  gdprRule?: Maybe<GdprRule>;
  gdprRules?: Maybe<Array<GdprRule>>;
  gearboxVariant?: Maybe<GearboxVariant>;
  gearboxVariants?: Maybe<Array<GearboxVariant>>;
  generateHints: Array<Scalars['String']>;
  getexRegulation?: Maybe<GetexRegulation>;
  history: GetHistoryOutput;
  icsCode?: Maybe<IcsCode>;
  icsCodes?: Maybe<Array<IcsCode>>;
  keyword?: Maybe<Keyword>;
  keywords?: Maybe<Array<Keyword>>;
  market?: Maybe<Market>;
  markets?: Maybe<Array<Market>>;
  matkonApplications?: Maybe<GetApplicationResponse>;
  matkonImdsApplications?: Maybe<GetImdsApplicationResponse>;
  matkonLimits?: Maybe<GetParagraphAdditionalInformationResponse>;
  matkonLimitsTemplate: MatkonFileResult;
  matkonParagraphAdditionalInformation?: Maybe<GetParagraphAdditionalInformationResponse>;
  me: User;
  myFavorites: Favorites;
  myGlobalAnnouncements: Array<GlobalAnnouncement>;
  myKeywords: Array<Keyword>;
  myRequirements: Array<Requirement>;
  myRequirementsReview: Array<Requirement>;
  mySubscriptions: Array<Subscription>;
  myTableConfigurations: Array<TableConfiguration>;
  myVKOKeywords: Array<Keyword>;
  myVexClusters: Array<VexCluster>;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Lookup nodes by a list of IDs. */
  nodes: Array<Maybe<Node>>;
  paragraphs: Array<RegulatoryDocumentParagraph>;
  paragraphsNext: Array<RegulatoryDocumentParagraph>;
  paragraphsQuery: ParagraphInfinityResults;
  paragraphsSortOrder: Array<InfinityParagraphId>;
  pdfContentType: GetHistoryOutput;
  pogisDocument?: Maybe<PogisDocument>;
  pogisDocumentsETB: Array<PogisDocument>;
  pogisDocumentsNext: Array<PogisDocument>;
  pogisDocumentsQuery: PogisDocumentsInfinityResults;
  pogisSortOrders: Array<Scalars['String']>;
  question?: Maybe<Question>;
  questionCategories?: Maybe<Array<QuestionCategory>>;
  questionCategory?: Maybe<QuestionCategory>;
  questionCountsByEntityType: Array<QuestionCount>;
  questions: Array<Question>;
  reference?: Maybe<Reference>;
  references?: Maybe<Array<Reference>>;
  regulation?: Maybe<Regulation>;
  regulationCluster?: Maybe<RegulationCluster>;
  regulationClusters?: Maybe<Array<RegulationCluster>>;
  regulations: Array<Regulation>;
  regulationsByPage?: Maybe<RegulationsByPageConnection>;
  regulationsByRegulationNumber: Array<Regulation>;
  regulationsNext: Array<Regulation>;
  regulationsQuery: RegulationsInfinityResults;
  regulationsSortOrder: Array<Scalars['String']>;
  regulatoryDocument?: Maybe<RegulatoryDocument>;
  regulatoryDocumentBlobReference?: Maybe<BlobRef>;
  regulatoryDocumentParagraph: RegulatoryDocumentParagraph;
  regulatoryDocuments?: Maybe<RegulatoryDocumentsConnection>;
  renameRegulationCusterRefs: RegulatoryDocumentClean;
  requirement?: Maybe<Requirement>;
  requirements: Array<Requirement>;
  requirementsNext: Array<Requirement>;
  requirementsQuery: RequirementsInfinityResults;
  requirementsSortOrder: Array<Scalars['String']>;
  requirementsWithAllocation: Array<Requirement>;
  requirementsWithoutAllocation: Array<Requirement>;
  runClean: RegulatoryDocumentClean;
  searchBaseline?: Maybe<Array<Baseline>>;
  searchMoreParagraphsTOC: Array<RegulatoryDocumentParagraph>;
  searchParagraphs: FullTextParagraphsResult;
  searchParagraphsForRegDoc: Array<RegulatoryDocumentParagraph>;
  searchPogisDocuments: FullTextPogisDocumentResult;
  searchRegulations: FullTextRegulationResult;
  searchRegulatoryDocuments: FullTextRegulatoryDocumentResult;
  searchRequirements: FullTextRequirementResult;
  sendEmail: Scalars['Int'];
  simulation?: Maybe<Simulation>;
  simulations: Array<Simulation>;
  standardPlusPcmsCluster?: Maybe<StandardPlusPcmsCluster>;
  standardPlusPcmsClusters?: Maybe<Array<StandardPlusPcmsCluster>>;
  suggestPogis: FullTextPogisDocumentResult;
  suggestRegulations: SuggestRegulationResult;
  suggestRegulatoryDocuments: SuggestDocumentResult;
  suggestRequirements: FullTextRequirementResult;
  systemLevel?: Maybe<SystemLevel>;
  systemLevels?: Maybe<Array<SystemLevel>>;
  tag?: Maybe<Tag>;
  tags?: Maybe<Array<Tag>>;
  user: User;
  userCreatedRegulations: Array<Regulation>;
  users?: Maybe<UsersConnection>;
  usersWithPermissions: Array<User>;
  vehicleCategories?: Maybe<Array<VehicleCategory>>;
  vehicleCategory?: Maybe<VehicleCategory>;
  vehicleProject?: Maybe<VehicleProject>;
  vehicleProjectBaselinesByModelAndSeries: Array<Baseline>;
  vehicleProjectMasterByModelSeriesAndGeneration?: Maybe<VehicleProjectMaster>;
  vehicleProjectMasterParagraphsQuery: ParagraphInfinityResults;
  vehicleProjectMasterRegulationsQuery: RegulationsInfinityResults;
  vehicleProjectMasterRequirementsNext: Array<AssignedRequirement>;
  vehicleProjectMasterRequirementsQuery?: Maybe<AssignedRequirementsInfinityResults>;
  vehicleProjectMasterWithProjectDetails: Array<VehicleProjectMasterWithProjectDetails>;
  vehicleProjects: Array<VehicleProject>;
  vehicleProjectsByModelSeriesAndGeneration: Array<VehicleProject>;
  vexCluster?: Maybe<VexCluster>;
  vexClusters?: Maybe<Array<VexCluster>>;
  vexRegulatoryDocumentParagraphs: Array<RegulatoryDocumentParagraph>;
  vexWorkbenchItems: Array<VexWorkbenchItemSimplified>;
  vko?: Maybe<Vko>;
  vkoApproverWorkbenchRegulatoryDocuments: VkoApproverWorkbenchResult;
  vkoWorkbenchRegulatoryDocumentParagraphs: Array<VkoWorkbenchItem>;
  vkos?: Maybe<Array<Vko>>;
  voProRegDocNext: Array<RegulatoryDocument>;
  voProRegDocQuery: RegDocInfinityResults;
  voProRegDocSortOrder: Array<Scalars['String']>;
  workbenchBaselines: Array<Baseline>;
  workbenchRegulatoryDocumentParagraphs: Array<VexWorkbenchItem>;
  workbenchRegulatoryDocuments: Array<RegulatoryDocument>;
};


export type QueryActiveTypeMarketArgs = {
  id: Scalars['ID'];
};


export type QueryActiveTypeMarketsArgs = {
  order?: InputMaybe<Array<ActiveTypeMarketSortInput>>;
};


export type QueryAllGetexRegulationsArgs = {
  order?: InputMaybe<Array<GetexRegulationSortInput>>;
  where?: InputMaybe<GetexRegulationFilterInput>;
};


export type QueryAttachmentCategoriesArgs = {
  order?: InputMaybe<Array<AttachmentCategorySortInput>>;
};


export type QueryAttachmentCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<AuditLogSortInput>>;
  where?: InputMaybe<AuditLogFilterInput>;
};


export type QueryBaselineByIdArgs = {
  id: Scalars['ID'];
};


export type QueryBaselineRequirementsNextArgs = {
  nextArgsBaselineRequirments: NextArgsBaselineRequirmentsInput;
};


export type QueryBaselineRequirementsQueryArgs = {
  queryArgsBaselineRequirments: QueryArgsBaselineRequirmentsInput;
};


export type QueryBodyworkVariantArgs = {
  id: Scalars['ID'];
};


export type QueryBodyworkVariantsArgs = {
  order?: InputMaybe<Array<BodyworkVariantSortInput>>;
};


export type QueryCanRegulationBeHiddenArgs = {
  id: Scalars['ID'];
};


export type QueryCategoriesArgs = {
  order?: InputMaybe<Array<CategorySortInput>>;
};


export type QueryCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryConvoluteArgs = {
  id: Scalars['ID'];
};


export type QueryConvolutesArgs = {
  order?: InputMaybe<Array<ConvoluteSortInput>>;
};


export type QueryCountriesArgs = {
  order?: InputMaybe<Array<CountrySortInput>>;
};


export type QueryCountryArgs = {
  id: Scalars['ID'];
};


export type QueryDocumentSourceArgs = {
  id: Scalars['ID'];
};


export type QueryDriveVariantArgs = {
  id: Scalars['ID'];
};


export type QueryDriveVariantsArgs = {
  order?: InputMaybe<Array<DriveVariantSortInput>>;
};


export type QueryEngineVariantArgs = {
  id: Scalars['ID'];
};


export type QueryEngineVariantsArgs = {
  order?: InputMaybe<Array<EngineVariantSortInput>>;
};


export type QueryEvaluateRegulationsArgs = {
  personId: Scalars['ID'];
};


export type QueryEvaluateRegulatoryDocumentParagraphsArgs = {
  personId: Scalars['ID'];
};


export type QueryEvaluateRegulatoryDocumentsArgs = {
  personId: Scalars['ID'];
};


export type QueryEvaluateRequirementsArgs = {
  personId: Scalars['ID'];
};


export type QueryEvaluateVehicleProjectsArgs = {
  personId: Scalars['ID'];
};


export type QueryGdprRuleArgs = {
  id: Scalars['ID'];
};


export type QueryGearboxVariantArgs = {
  id: Scalars['ID'];
};


export type QueryGearboxVariantsArgs = {
  order?: InputMaybe<Array<GearboxVariantSortInput>>;
};


export type QueryGenerateHintsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  searchString: Scalars['String'];
};


export type QueryGetexRegulationArgs = {
  id: Scalars['ID'];
};


export type QueryHistoryArgs = {
  batchIndex: Scalars['Int'];
  batchSize: Scalars['Int'];
};


export type QueryIcsCodeArgs = {
  id: Scalars['ID'];
};


export type QueryIcsCodesArgs = {
  order?: InputMaybe<Array<IcsCodeSortInput>>;
};


export type QueryKeywordArgs = {
  id: Scalars['ID'];
};


export type QueryKeywordsArgs = {
  order?: InputMaybe<Array<KeywordSortInput>>;
};


export type QueryMarketArgs = {
  id: Scalars['ID'];
};


export type QueryMarketsArgs = {
  order?: InputMaybe<Array<MarketSortInput>>;
};


export type QueryMatkonLimitsArgs = {
  paragraphId: Scalars['ID'];
  regulationNumber: Scalars['String'];
};


export type QueryMatkonParagraphAdditionalInformationArgs = {
  regulationNumber: Scalars['String'];
};


export type QueryMyGlobalAnnouncementsArgs = {
  myRoles: Array<Scalars['String']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryParagraphsArgs = {
  paragraphIds: Array<Scalars['String']>;
};


export type QueryParagraphsNextArgs = {
  nextParaArgs: NextArgsParagraphsInput;
};


export type QueryParagraphsQueryArgs = {
  queryParaArgs: QueryArgsParagraphsInput;
};


export type QueryParagraphsSortOrderArgs = {
  sortParaArgs: SortArgsParagraphsInput;
};


export type QueryPdfContentTypeArgs = {
  batchIndex: Scalars['Int'];
  batchSize: Scalars['Int'];
};


export type QueryPogisDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryPogisDocumentsNextArgs = {
  nextArgs: NextArgsInput;
};


export type QueryPogisDocumentsQueryArgs = {
  queryArgs: QueryArgsInput;
};


export type QueryPogisSortOrdersArgs = {
  sortArgs: SortArgsInput;
};


export type QueryQuestionArgs = {
  id: Scalars['ID'];
};


export type QueryQuestionCategoriesArgs = {
  order?: InputMaybe<Array<QuestionCategorySortInput>>;
};


export type QueryQuestionCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryQuestionCountsByEntityTypeArgs = {
  entityType: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
};


export type QueryQuestionsArgs = {
  targetRecordId: Scalars['ID'];
};


export type QueryReferenceArgs = {
  id: Scalars['ID'];
};


export type QueryReferencesArgs = {
  order?: InputMaybe<Array<ReferenceSortInput>>;
};


export type QueryRegulationArgs = {
  id: Scalars['ID'];
};


export type QueryRegulationClusterArgs = {
  id: Scalars['ID'];
};


export type QueryRegulationClustersArgs = {
  order?: InputMaybe<Array<RegulationClusterSortInput>>;
};


export type QueryRegulationsByPageArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryRegulationsByRegulationNumberArgs = {
  regulationNumber: Scalars['String'];
};


export type QueryRegulationsNextArgs = {
  nextArgs: NextArgsInput;
};


export type QueryRegulationsQueryArgs = {
  queryArgs: QueryArgsInput;
};


export type QueryRegulationsSortOrderArgs = {
  sortArgs: SortArgsInput;
};


export type QueryRegulatoryDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryRegulatoryDocumentBlobReferenceArgs = {
  id: Scalars['ID'];
};


export type QueryRegulatoryDocumentParagraphArgs = {
  paragraphId: Scalars['ID'];
  regulationId?: InputMaybe<Scalars['ID']>;
  regulatoryDocumentId: Scalars['ID'];
};


export type QueryRegulatoryDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<RegulatoryDocumentSortInput>>;
  where?: InputMaybe<RegulatoryDocumentFilterInput>;
};


export type QueryRenameRegulationCusterRefsArgs = {
  batchIndex: Scalars['Int'];
  batchSize: Scalars['Int'];
};


export type QueryRequirementArgs = {
  id: Scalars['ID'];
};


export type QueryRequirementsArgs = {
  order?: InputMaybe<Array<RequirementSortInput>>;
  where?: InputMaybe<RequirementFilterInput>;
};


export type QueryRequirementsNextArgs = {
  nextArgs: NextArgsInput;
};


export type QueryRequirementsQueryArgs = {
  queryArgs: QueryArgsInput;
};


export type QueryRequirementsSortOrderArgs = {
  sortArgs: SortArgsInput;
};


export type QueryRunCleanArgs = {
  batchIndex: Scalars['Int'];
  batchSize: Scalars['Int'];
};


export type QuerySearchBaselineArgs = {
  searchString: Scalars['String'];
};


export type QuerySearchMoreParagraphsTocArgs = {
  paraId: Array<Scalars['ID']>;
  regulatoryDocumentID: Scalars['ID'];
};


export type QuerySearchParagraphsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  searchString: Scalars['String'];
};


export type QuerySearchParagraphsForRegDocArgs = {
  regulatoryDocumentID: Scalars['ID'];
  searchString: Scalars['String'];
};


export type QuerySearchPogisDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  searchString: Scalars['String'];
};


export type QuerySearchRegulationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  searchString: Scalars['String'];
};


export type QuerySearchRegulatoryDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  searchString: Scalars['String'];
};


export type QuerySearchRequirementsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  searchString: Scalars['String'];
};


export type QuerySendEmailArgs = {
  eventInitiator: BaseUserInput;
  htmlBody: Scalars['String'];
  recipients: Array<UserInput>;
  subject: Scalars['String'];
};


export type QuerySimulationArgs = {
  id: Scalars['ID'];
};


export type QueryStandardPlusPcmsClusterArgs = {
  id: Scalars['ID'];
};


export type QueryStandardPlusPcmsClustersArgs = {
  order?: InputMaybe<Array<StandardPlusPcmsClusterSortInput>>;
};


export type QuerySuggestPogisArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  searchString: Scalars['String'];
};


export type QuerySuggestRegulationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  searchString: Scalars['String'];
};


export type QuerySuggestRegulatoryDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  searchString: Scalars['String'];
};


export type QuerySuggestRequirementsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  searchString: Scalars['String'];
};


export type QuerySystemLevelArgs = {
  id: Scalars['ID'];
};


export type QueryTagArgs = {
  id: Scalars['ID'];
};


export type QueryUserArgs = {
  id: Scalars['String'];
};


export type QueryUserCreatedRegulationsArgs = {
  userId: Scalars['String'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<QueryableScope_UserSortInput>>;
  role?: InputMaybe<UserRole>;
  searchString: Scalars['String'];
};


export type QueryUsersWithPermissionsArgs = {
  modelSeries: Scalars['String'];
};


export type QueryVehicleCategoriesArgs = {
  order?: InputMaybe<Array<VehicleCategorySortInput>>;
};


export type QueryVehicleCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryVehicleProjectArgs = {
  id: Scalars['ID'];
};


export type QueryVehicleProjectBaselinesByModelAndSeriesArgs = {
  generation: Scalars['String'];
  modelSeries: Scalars['String'];
};


export type QueryVehicleProjectMasterByModelSeriesAndGenerationArgs = {
  generation: Scalars['String'];
  modelSeries: Scalars['String'];
};


export type QueryVehicleProjectMasterParagraphsQueryArgs = {
  queryArgAssignedParagraphs: QueryArgsAssignedEntityInput;
};


export type QueryVehicleProjectMasterRegulationsQueryArgs = {
  queryArgAssignedRegulations: QueryArgsAssignedEntityInput;
};


export type QueryVehicleProjectMasterRequirementsNextArgs = {
  nextArgAssignedRequirements: NextArgsAssignedEntityInput;
};


export type QueryVehicleProjectMasterRequirementsQueryArgs = {
  queryArgAssignedRequirements: QueryArgsAssignedEntityInput;
};


export type QueryVehicleProjectsByModelSeriesAndGenerationArgs = {
  generation: Scalars['String'];
  modelSeries: Scalars['String'];
};


export type QueryVexClusterArgs = {
  id: Scalars['ID'];
};


export type QueryVexClustersArgs = {
  order?: InputMaybe<Array<VexClusterSortInput>>;
  where?: InputMaybe<VexClusterFilterInput>;
};


export type QueryVexRegulatoryDocumentParagraphsArgs = {
  inProcess: Scalars['Boolean'];
  regulatoryDocumentId: Scalars['ID'];
  where?: InputMaybe<RegulatoryDocumentFilterInput>;
};


export type QueryVexWorkbenchItemsArgs = {
  keywordStatus: KeywordStatus;
  where?: InputMaybe<RegulatoryDocumentFilterInput>;
};


export type QueryVkoArgs = {
  id: Scalars['ID'];
};


export type QueryVkoApproverWorkbenchRegulatoryDocumentsArgs = {
  where?: InputMaybe<RegulatoryDocumentFilterInput>;
};


export type QueryVoProRegDocNextArgs = {
  nextArgs: NextArgsInput;
};


export type QueryVoProRegDocQueryArgs = {
  queryArgs: QueryArgsInput;
};


export type QueryVoProRegDocSortOrderArgs = {
  sortArgs: SortArgsInput;
};


export type QueryWorkbenchRegulatoryDocumentParagraphsArgs = {
  keywordStatus: KeywordStatus;
  where?: InputMaybe<RegulatoryDocumentFilterInput>;
};


export type QueryWorkbenchRegulatoryDocumentsArgs = {
  where?: InputMaybe<RegulatoryDocumentFilterInput>;
};

export type QueryArgsAssignedEntityInput = {
  generation: Scalars['String'];
  modelSeries: Scalars['String'];
  queryArgs: QueryArgsInput;
  queryAssignedReq?: InputMaybe<Scalars['String']>;
  queryRegdoc?: InputMaybe<Scalars['String']>;
};

export type QueryArgsBaselineRequirmentsInput = {
  baselineId: Scalars['String'];
  queryArgs: QueryArgsInput;
  queryAssignedReq?: InputMaybe<Scalars['String']>;
};

export type QueryArgsInput = {
  batchSize?: Scalars['Int'];
  preFilteredIds?: InputMaybe<Array<Scalars['String']>>;
  query: Scalars['String'];
  sortField: Scalars['String'];
  sortOrder: Scalars['String'];
};

export type QueryArgsParagraphsInput = {
  preFilteredParagraphIds: Array<InfinityParagraphIdInput>;
  queryArgs: QueryArgsInput;
  queryRegdoc: Scalars['String'];
};

export enum QueryableScope_SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type QueryableScope_UserSortInput = {
  givenName?: InputMaybe<QueryableScope_SortEnumType>;
  id?: InputMaybe<QueryableScope_SortEnumType>;
  mail?: InputMaybe<QueryableScope_SortEnumType>;
  name?: InputMaybe<QueryableScope_SortEnumType>;
  surname?: InputMaybe<QueryableScope_SortEnumType>;
  userPrincipalName?: InputMaybe<QueryableScope_SortEnumType>;
};

export type Question = Entity & NamedEntity & Node & {
  __typename?: 'Question';
  answers?: Maybe<Array<Answer>>;
  attachments?: Maybe<Array<AttachmentRef>>;
  category?: Maybe<QuestionCategory>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  keywords: Array<Keyword>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  roles?: Maybe<Array<Scalars['String']>>;
  targetCollection?: Maybe<Scalars['String']>;
  targetRecords: Array<TargetCollection>;
  targetUsers: Array<User>;
  translations?: Maybe<Array<TranslationObject>>;
  vehicleProjects: Array<VehicleProject>;
};


export type QuestionNameArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
};

export type QuestionCategory = Entity & NamedEntity & Node & {
  __typename?: 'QuestionCategory';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  translations?: Maybe<Array<TranslationObject>>;
};


export type QuestionCategoryNameArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
};

export type QuestionCategorySortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type QuestionCount = {
  __typename?: 'QuestionCount';
  count: Scalars['Int'];
  entityId?: Maybe<Scalars['String']>;
};

export type QuestionPayload = {
  __typename?: 'QuestionPayload';
  requirement: Question;
};

export type ReassignAllRegulatoryDocumentsForClonedRequirementInput = {
  additionalParagraphIds?: InputMaybe<Array<Scalars['ID']>>;
  additionalRegDocId?: InputMaybe<Scalars['ID']>;
  distRequirementId: Scalars['ID'];
  sourceRequirementId: Scalars['ID'];
};

export type ReassignAllRegulatoryDocumentsForClonedRequirementPayload = {
  __typename?: 'ReassignAllRegulatoryDocumentsForClonedRequirementPayload';
  boolean?: Maybe<Scalars['Boolean']>;
};

export type Reference = Entity & NamedEntity & Node & {
  __typename?: 'Reference';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  referenceTypes: Array<ReferenceType>;
  translations?: Maybe<Array<TranslationObject>>;
};


export type ReferenceNameArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
};

export type ReferenceGroup = {
  __typename?: 'ReferenceGroup';
  regulationReference?: Maybe<Regulation>;
  regulatoryDocumentReferences?: Maybe<Array<Maybe<RegulatoryDocument>>>;
  selectAllRegulatoryDocuments: Scalars['Boolean'];
};

export type ReferenceGroupFilterInput = {
  and?: InputMaybe<Array<ReferenceGroupFilterInput>>;
  or?: InputMaybe<Array<ReferenceGroupFilterInput>>;
  regulationReference?: InputMaybe<EntityRefOfRegulationFilterInput>;
  regulatoryDocumentReferences?: InputMaybe<ListFilterInputTypeOfEntityRefOfRegulatoryDocumentFilterInput>;
  selectAllRegulatoryDocuments?: InputMaybe<BooleanOperationFilterInput>;
};

export type ReferenceGroupInput = {
  regulationReference?: InputMaybe<EntityRefOfRegulationInput>;
  regulatoryDocumentReferences: Array<EntityRefOfRegulatoryDocumentInput>;
  selectAllRegulatoryDocuments: Scalars['Boolean'];
};

export type ReferenceSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export enum ReferenceType {
  Paragraph = 'PARAGRAPH',
  Regulation = 'REGULATION',
  RegulatoryDocument = 'REGULATORY_DOCUMENT',
  Requirement = 'REQUIREMENT'
}

export type RegDocFilterOptions = {
  __typename?: 'RegDocFilterOptions';
  contactPersonOptions: Array<FilterOption>;
  keywordOptions: Array<FilterOption>;
  mainKeywordOptions: Array<FilterOption>;
  marketOptions: Array<FilterOption>;
  modelYearOptions: Array<FilterOption>;
  regulationOptions: Array<FilterOption>;
  statusOptions: Array<FilterOption>;
  workFlowOptions: Array<FilterOption>;
};

export type RegDocInfinityResults = {
  __typename?: 'RegDocInfinityResults';
  regDocFilterOptions: RegDocFilterOptions;
  regDocIds: Array<Scalars['String']>;
  regDocsBatch: Array<RegulatoryDocument>;
};

export type Regulation = Entity & NamedEntity & Node & {
  __typename?: 'Regulation';
  anonymous: Scalars['Boolean'];
  attachments?: Maybe<Array<AttachmentRef>>;
  auditLog: Array<AuditLog>;
  comments?: Maybe<Array<Commentary>>;
  contactPersons: Array<User>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  deletionPeriod: Scalars['Int'];
  driveVariants: Array<DriveVariant>;
  faqs?: Maybe<Array<Faq>>;
  hidden: Scalars['Boolean'];
  icsCodes: Array<IcsCode>;
  id: Scalars['ID'];
  isMachineRegulation: Scalars['Boolean'];
  keywords: Array<Keyword>;
  mainKeywords: Array<Keyword>;
  markets: Array<Market>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  regulationClusters: Array<RegulationCluster>;
  regulationNumber: Scalars['String'];
  regulatoryDocuments: Array<RegulatoryDocument>;
  source?: Maybe<Scalars['String']>;
  standardPlusPcmsClusters: Array<StandardPlusPcmsCluster>;
  summary: Scalars['String'];
  vehicleCategories: Array<VehicleCategory>;
  willBeAnonymized: Scalars['Boolean'];
};


export type RegulationRegulatoryDocumentsArgs = {
  order?: InputMaybe<Array<RegulatoryDocumentSortInput>>;
  where?: InputMaybe<RegulatoryDocumentFilterInput>;
};

export type RegulationAttachmentsPayload = {
  __typename?: 'RegulationAttachmentsPayload';
  regulationAttachments?: Maybe<UpdateEntityAttachmentsResult>;
};

export type RegulationCluster = Entity & NamedEntity & Node & {
  __typename?: 'RegulationCluster';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
};

export type RegulationClusterSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type RegulationFilterOptions = {
  __typename?: 'RegulationFilterOptions';
  icsCodeOptions: Array<FilterOption>;
  keywordOptions: Array<FilterOption>;
  mainKeywordOptions: Array<FilterOption>;
  marketOptions: Array<FilterOption>;
  pcmsOptions: Array<FilterOption>;
  regulationOptions: Array<FilterOption>;
};

export type RegulationPayload = {
  __typename?: 'RegulationPayload';
  regulation: Regulation;
};

/** A connection to a list of items. */
export type RegulationsByPageConnection = {
  __typename?: 'RegulationsByPageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RegulationsByPageEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Regulation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type RegulationsByPageEdge = {
  __typename?: 'RegulationsByPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Regulation;
};

export type RegulationsInfinityResults = {
  __typename?: 'RegulationsInfinityResults';
  regulationFilterOptions: RegulationFilterOptions;
  regulationIds: Array<Scalars['String']>;
  regulationsBatch: Array<Regulation>;
};

export type RegulatoryDocument = Entity & NamedEntity & Node & {
  __typename?: 'RegulatoryDocument';
  anonymous: Scalars['Boolean'];
  attachments?: Maybe<Array<AttachmentRef>>;
  changeHistoryAuditLogs: Array<AuditLog>;
  childrenRefs?: Maybe<Array<RegulatoryDocument>>;
  clearingAuditLogs: Array<AuditLog>;
  comments?: Maybe<Array<Commentary>>;
  comprehensive?: Maybe<Scalars['Date']>;
  contactPersons: Array<User>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  dateEffective?: Maybe<Scalars['Date']>;
  dateExpiration?: Maybe<Scalars['Date']>;
  dateNewRegistration?: Maybe<Scalars['Date']>;
  dateNewTypes?: Maybe<Scalars['Date']>;
  dateOfClearance?: Maybe<Scalars['DateTime']>;
  deletionPeriod: Scalars['Int'];
  disassemblyStatus: RegulatoryDocumentDisassemblyStatus;
  document?: Maybe<BlobRef>;
  documentError?: Maybe<Scalars['String']>;
  documentReferences?: Maybe<Array<DocumentReference>>;
  documentSource?: Maybe<DocumentSource>;
  documentStatus: DocumentStatus;
  driveVariants: Array<DriveVariant>;
  faqs?: Maybe<Array<Faq>>;
  finalVersionRef?: Maybe<RegulatoryDocument>;
  hash?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  keywords: Array<Keyword>;
  mainKeywords: Array<Keyword>;
  markets: Array<Market>;
  modelYear?: Maybe<Scalars['Int']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  origin: Origin;
  paragraphs: Array<RegulatoryDocumentParagraph>;
  phaseIn: Array<PhaseDate>;
  phaseOut: Array<PhaseDate>;
  pogisDocuments: Array<PogisDocument>;
  pogisExists: Scalars['Boolean'];
  predecessor?: Maybe<RegulatoryDocument>;
  predecessors?: Maybe<Array<RegulatoryDocument>>;
  regulation?: Maybe<Regulation>;
  serviceProviders: Array<User>;
  status: RegulatoryDocumentStatus;
  successor?: Maybe<RegulatoryDocument>;
  summary?: Maybe<Scalars['String']>;
  topicManagementSummary?: Maybe<TopicManagementSummary>;
  vehicleCategories: Array<VehicleCategory>;
  willBeAnonymized: Scalars['Boolean'];
  workflow: Workflow;
};

export type RegulatoryDocumentAssetPayload = {
  __typename?: 'RegulatoryDocumentAssetPayload';
  regulatoryDocumentAsset?: Maybe<BlobRef>;
};

export type RegulatoryDocumentAttachmentsPayload = {
  __typename?: 'RegulatoryDocumentAttachmentsPayload';
  regulatoryDocumentAttachments?: Maybe<UpdateEntityAttachmentsResult>;
};

export type RegulatoryDocumentClean = Entity & {
  __typename?: 'RegulatoryDocumentClean';
  attachments?: Maybe<Array<AttachmentRef>>;
  batchIndex: Scalars['Int'];
  batchSize: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  regulatoryDocumentNames: Array<Scalars['String']>;
  regulatoryDocumentsName: Array<Scalars['String']>;
  totalCount: Scalars['Int'];
  updatedDocumentIndex: Array<Scalars['Int']>;
};

export enum RegulatoryDocumentDisassemblyStatus {
  DisassembleLater = 'DISASSEMBLE_LATER',
  DisassemblyNotRequired = 'DISASSEMBLY_NOT_REQUIRED',
  DisassemblyOccured = 'DISASSEMBLY_OCCURED'
}

export type RegulatoryDocumentDisassemblyStatusOperationFilterInput = {
  eq?: InputMaybe<RegulatoryDocumentDisassemblyStatus>;
  in?: InputMaybe<Array<RegulatoryDocumentDisassemblyStatus>>;
  neq?: InputMaybe<RegulatoryDocumentDisassemblyStatus>;
  nin?: InputMaybe<Array<RegulatoryDocumentDisassemblyStatus>>;
};

export type RegulatoryDocumentFilePayloadWithAttachments = {
  __typename?: 'RegulatoryDocumentFilePayloadWithAttachments';
  errors?: Maybe<Array<UploadRegulatoryDocumentWithAttachmentsError>>;
  regulatoryDocumentFileWithAttachments?: Maybe<BlobRef>;
};

export enum RegulatoryDocumentFileType {
  Pdf = 'PDF',
  ReqIf = 'REQ_IF'
}

export type RegulatoryDocumentFilterInput = {
  and?: InputMaybe<Array<RegulatoryDocumentFilterInput>>;
  anonymous?: InputMaybe<BooleanOperationFilterInput>;
  comments?: InputMaybe<ListFilterInputTypeOfCommentaryFilterInput>;
  comprehensive?: InputMaybe<DateTimeOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  dateEffective?: InputMaybe<DateTimeOperationFilterInput>;
  dateExpiration?: InputMaybe<DateTimeOperationFilterInput>;
  dateNewRegistration?: InputMaybe<DateTimeOperationFilterInput>;
  dateNewTypes?: InputMaybe<DateTimeOperationFilterInput>;
  dateOfClearance?: InputMaybe<DateTimeOperationFilterInput>;
  deletionPeriod?: InputMaybe<IntOperationFilterInput>;
  disassemblyStatus?: InputMaybe<RegulatoryDocumentDisassemblyStatusOperationFilterInput>;
  documentError?: InputMaybe<StringOperationFilterInput>;
  documentReferences?: InputMaybe<ListFilterInputTypeOfDocumentReferenceFilterInput>;
  documentStatus?: InputMaybe<DocumentStatusOperationFilterInput>;
  faqs?: InputMaybe<ListFilterInputTypeOfFaqFilterInput>;
  hash?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IdOperationFilterInput>;
  modelYear?: InputMaybe<IntOperationFilterInput>;
  modifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RegulatoryDocumentFilterInput>>;
  origin?: InputMaybe<OriginOperationFilterInput>;
  paragraphs?: InputMaybe<ListFilterInputTypeOfRegulatoryDocumentParagraphFilterInput>;
  phaseIn?: InputMaybe<ListFilterInputTypeOfPhaseDateFilterInput>;
  phaseOut?: InputMaybe<ListFilterInputTypeOfPhaseDateFilterInput>;
  pogisExists?: InputMaybe<BooleanOperationFilterInput>;
  regulationRef?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<RegulatoryDocumentStatusOperationFilterInput>;
  summary?: InputMaybe<StringOperationFilterInput>;
  topicManagementSummary?: InputMaybe<TopicManagementSummaryFilterInput>;
  willBeAnonymized?: InputMaybe<BooleanOperationFilterInput>;
  workflow?: InputMaybe<WorkflowFilterInput>;
};

export type RegulatoryDocumentParagraph = Entity & {
  __typename?: 'RegulatoryDocumentParagraph';
  attachments?: Maybe<Array<AttachmentRef>>;
  auditLog: Array<AuditLog>;
  categories: Array<Category>;
  changeInfoType: ChangeInfoType;
  comments?: Maybe<Array<Commentary>>;
  comprehensive?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  dateNewRegistration?: Maybe<Scalars['Date']>;
  dateNewTypes?: Maybe<Scalars['Date']>;
  driveVariants: Array<DriveVariant>;
  elements: Array<RegulatoryDocumentParagraphElement>;
  enumeration: Scalars['String'];
  faqs?: Maybe<Array<Faq>>;
  id: Scalars['ID'];
  isFootnote: Scalars['Boolean'];
  keywordAssignments?: Maybe<Array<KeywordAssignment>>;
  keywords: Array<Keyword>;
  level: Scalars['Int'];
  modelYear?: Maybe<Scalars['Int']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  page: Scalars['Int'];
  parent: RegulatoryDocument;
  phaseIn?: Maybe<Array<PhaseDate>>;
  phaseOut?: Maybe<Array<PhaseDate>>;
  position: Scalars['Int'];
  positionDB?: Maybe<Scalars['Int']>;
  reqIfSpecId?: Maybe<Scalars['String']>;
  requirements: Array<Requirement>;
  summary?: Maybe<Scalars['String']>;
  tags: Array<Tag>;
  vehicleCategories: Array<VehicleCategory>;
};

export type RegulatoryDocumentParagraphElement = {
  __typename?: 'RegulatoryDocumentParagraphElement';
  asset?: Maybe<BlobRef>;
  assetId?: Maybe<Scalars['String']>;
  bounds?: Maybe<Array<Scalars['Float']>>;
  csvContent?: Maybe<Scalars['String']>;
  isHeader: Scalars['Boolean'];
  page: Scalars['Int'];
  text?: Maybe<Scalars['String']>;
  textPosition?: Maybe<TextPosition>;
  type: ParagraphElementType;
};

export type RegulatoryDocumentParagraphElementFilterInput = {
  and?: InputMaybe<Array<RegulatoryDocumentParagraphElementFilterInput>>;
  assetId?: InputMaybe<StringOperationFilterInput>;
  bounds?: InputMaybe<ListFloatOperationFilterInput>;
  csvContent?: InputMaybe<StringOperationFilterInput>;
  isHeader?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<RegulatoryDocumentParagraphElementFilterInput>>;
  page?: InputMaybe<IntOperationFilterInput>;
  text?: InputMaybe<StringOperationFilterInput>;
  textPosition?: InputMaybe<NullableOfTextPositionOperationFilterInput>;
  type?: InputMaybe<ParagraphElementTypeOperationFilterInput>;
};

export type RegulatoryDocumentParagraphElementInput = {
  assetId?: InputMaybe<Scalars['String']>;
  bounds?: InputMaybe<Array<Scalars['Float']>>;
  csvContent?: InputMaybe<Scalars['String']>;
  isHeader: Scalars['Boolean'];
  page: Scalars['Int'];
  text?: InputMaybe<Scalars['String']>;
  textPosition?: InputMaybe<TextPosition>;
  type: ParagraphElementType;
};

export type RegulatoryDocumentParagraphFilterInput = {
  and?: InputMaybe<Array<RegulatoryDocumentParagraphFilterInput>>;
  changeInfoType?: InputMaybe<ChangeInfoTypeOperationFilterInput>;
  comments?: InputMaybe<ListFilterInputTypeOfCommentaryFilterInput>;
  comprehensive?: InputMaybe<DateTimeOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  dateNewRegistration?: InputMaybe<DateTimeOperationFilterInput>;
  dateNewTypes?: InputMaybe<DateTimeOperationFilterInput>;
  elements?: InputMaybe<ListFilterInputTypeOfRegulatoryDocumentParagraphElementFilterInput>;
  enumeration?: InputMaybe<StringOperationFilterInput>;
  faqs?: InputMaybe<ListFilterInputTypeOfFaqFilterInput>;
  id?: InputMaybe<IdOperationFilterInput>;
  isFootnote?: InputMaybe<BooleanOperationFilterInput>;
  keywordAssignments?: InputMaybe<ListFilterInputTypeOfKeywordAssignmentFilterInput>;
  level?: InputMaybe<IntOperationFilterInput>;
  modelYear?: InputMaybe<IntOperationFilterInput>;
  modifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<RegulatoryDocumentParagraphFilterInput>>;
  page?: InputMaybe<IntOperationFilterInput>;
  parent?: InputMaybe<RegulatoryDocumentFilterInput>;
  phaseIn?: InputMaybe<ListFilterInputTypeOfPhaseDateFilterInput>;
  phaseOut?: InputMaybe<ListFilterInputTypeOfPhaseDateFilterInput>;
  positionDB?: InputMaybe<IntOperationFilterInput>;
  reqIfSpecId?: InputMaybe<StringOperationFilterInput>;
  summary?: InputMaybe<StringOperationFilterInput>;
};

export type RegulatoryDocumentPayload = {
  __typename?: 'RegulatoryDocumentPayload';
  regulatoryDocument: RegulatoryDocument;
};

export type RegulatoryDocumentSortInput = {
  anonymous?: InputMaybe<SortEnumType>;
  comprehensive?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  dateEffective?: InputMaybe<SortEnumType>;
  dateExpiration?: InputMaybe<SortEnumType>;
  dateNewRegistration?: InputMaybe<SortEnumType>;
  dateNewTypes?: InputMaybe<SortEnumType>;
  dateOfClearance?: InputMaybe<SortEnumType>;
  deletionPeriod?: InputMaybe<SortEnumType>;
  disassemblyStatus?: InputMaybe<SortEnumType>;
  documentError?: InputMaybe<SortEnumType>;
  documentStatus?: InputMaybe<SortEnumType>;
  hash?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modelYear?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  origin?: InputMaybe<SortEnumType>;
  pogisExists?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  summary?: InputMaybe<SortEnumType>;
  topicManagementSummary?: InputMaybe<TopicManagementSummarySortInput>;
  willBeAnonymized?: InputMaybe<SortEnumType>;
  workflow?: InputMaybe<WorkflowSortInput>;
};

export enum RegulatoryDocumentStatus {
  Consideration = 'CONSIDERATION',
  Discarded = 'DISCARDED',
  Draft = 'DRAFT',
  Final = 'FINAL',
  GroupPrognosis = 'GROUP_PROGNOSIS',
  Ineffective = 'INEFFECTIVE',
  Interpretation = 'INTERPRETATION'
}

export type RegulatoryDocumentStatusOperationFilterInput = {
  eq?: InputMaybe<RegulatoryDocumentStatus>;
  in?: InputMaybe<Array<RegulatoryDocumentStatus>>;
  neq?: InputMaybe<RegulatoryDocumentStatus>;
  nin?: InputMaybe<Array<RegulatoryDocumentStatus>>;
};

/** A connection to a list of items. */
export type RegulatoryDocumentsConnection = {
  __typename?: 'RegulatoryDocumentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RegulatoryDocumentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RegulatoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RegulatoryDocumentsEdge = {
  __typename?: 'RegulatoryDocumentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: RegulatoryDocument;
};

export enum RejectReasonOption {
  NoDerivation = 'NO_DERIVATION',
  WrongKeyword = 'WRONG_KEYWORD'
}

export type RejectReasonOptionOperationFilterInput = {
  eq?: InputMaybe<RejectReasonOption>;
  in?: InputMaybe<Array<RejectReasonOption>>;
  neq?: InputMaybe<RejectReasonOption>;
  nin?: InputMaybe<Array<RejectReasonOption>>;
};

export type RemoveAssignedVehicleProjectRequirementsInput = {
  generation: Scalars['String'];
  modelSeries: Scalars['String'];
  requirementIds: Array<Scalars['ID']>;
};

export type RemoveAssignedVehicleProjectRequirementsPayload = {
  __typename?: 'RemoveAssignedVehicleProjectRequirementsPayload';
  vehicleProjectMaster?: Maybe<VehicleProjectMaster>;
};

export type RemoveRegulatoryDocumentParagraphsRequirementsInput = {
  paragraphIds: Array<Scalars['ID']>;
  regulatoryDocumentId: Scalars['ID'];
  requirementRefs: Array<EntityRefOfRequirementInput>;
};

export type RemoveRegulatoryDocumentParagraphsRequirementsPayload = {
  __typename?: 'RemoveRegulatoryDocumentParagraphsRequirementsPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type RemoveVehicleProjectPermissionsInput = {
  modelSeries: Scalars['String'];
  user: Scalars['ID'];
};

export type RemoveVehicleProjectPermissionsPayload = {
  __typename?: 'RemoveVehicleProjectPermissionsPayload';
  user?: Maybe<User>;
};

export type ReplaceVersionMetadataInput = {
  distParagraphIds: Array<Scalars['ID']>;
  distRegulatoryDocumentId: Scalars['ID'];
  sourceParagraphIds: Array<Scalars['ID']>;
  sourceRegulatoryDocumentId: Scalars['ID'];
  updateFields: CopyVersionMetadataUpdateFieldsInput;
};

export type ReplaceVersionMetadataPayload = {
  __typename?: 'ReplaceVersionMetadataPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export enum ReportEventType {
  KeywordVexExport = 'KEYWORD_VEX_EXPORT',
  None = 'NONE'
}

export type Requirement = Entity & NamedEntity & Node & {
  __typename?: 'Requirement';
  activeTypeMarkets: Array<ActiveTypeMarket>;
  aggregatedFields: AggregatedFields;
  anonymous: Scalars['Boolean'];
  approvalWorkFlow?: Maybe<ApprovalWorkFlow>;
  assignedParagraphs: Array<RegulatoryDocumentParagraph>;
  assignedParagraphsOld: Array<RegulatoryDocumentParagraph>;
  attachments?: Maybe<Array<AttachmentRef>>;
  auditLog: Array<AuditLog>;
  bodyworkVariants: Array<BodyworkVariant>;
  category: RequirementCategory;
  changeType: RequirementChangeType;
  childrenRefs?: Maybe<Array<Requirement>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  dateEffective?: Maybe<Scalars['Date']>;
  dateExpiration?: Maybe<Scalars['Date']>;
  definition?: Maybe<Scalars['String']>;
  deletionPeriod: Scalars['Int'];
  documentReferences?: Maybe<Array<DocumentReference>>;
  driveVariants: Array<DriveVariant>;
  engineVariants: Array<EngineVariant>;
  gearboxVariants: Array<GearboxVariant>;
  id: Scalars['ID'];
  keywords: Array<Keyword>;
  markets: Array<Market>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  parentRef?: Maybe<Requirement>;
  requirementId?: Maybe<Scalars['String']>;
  status: RequirementStatus;
  successor?: Maybe<Requirement>;
  systemLevelRefs: Array<EntityRefOfSystemLevel>;
  systemLevels: Array<SystemLevel>;
  tags: Array<Tag>;
  translations?: Maybe<Array<TranslationObject>>;
  vehicleCategories: Array<VehicleCategory>;
  version?: Maybe<Scalars['String']>;
  vexClusters: Array<VexCluster>;
  willBeAnonymized: Scalars['Boolean'];
};


export type RequirementNameArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
};

export type RequirementAttachmentsPayload = {
  __typename?: 'RequirementAttachmentsPayload';
  requirementAttachments?: Maybe<UpdateEntityAttachmentsResult>;
};

export enum RequirementCategory {
  ProcessRequirement = 'PROCESS_REQUIREMENT',
  ProductRequirement = 'PRODUCT_REQUIREMENT',
  TestRequirement = 'TEST_REQUIREMENT'
}

export type RequirementCategoryOperationFilterInput = {
  eq?: InputMaybe<RequirementCategory>;
  in?: InputMaybe<Array<RequirementCategory>>;
  neq?: InputMaybe<RequirementCategory>;
  nin?: InputMaybe<Array<RequirementCategory>>;
};

export enum RequirementChangeType {
  Content = 'CONTENT',
  Editorial = 'EDITORIAL',
  None = 'NONE'
}

export type RequirementChangeTypeOperationFilterInput = {
  eq?: InputMaybe<RequirementChangeType>;
  in?: InputMaybe<Array<RequirementChangeType>>;
  neq?: InputMaybe<RequirementChangeType>;
  nin?: InputMaybe<Array<RequirementChangeType>>;
};

export type RequirementFilterInput = {
  and?: InputMaybe<Array<RequirementFilterInput>>;
  anonymous?: InputMaybe<BooleanOperationFilterInput>;
  approvalWorkFlow?: InputMaybe<ApprovalWorkFlowFilterInput>;
  category?: InputMaybe<RequirementCategoryOperationFilterInput>;
  changeType?: InputMaybe<RequirementChangeTypeOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  dateEffective?: InputMaybe<DateTimeOperationFilterInput>;
  dateExpiration?: InputMaybe<DateTimeOperationFilterInput>;
  definition?: InputMaybe<StringOperationFilterInput>;
  deletionPeriod?: InputMaybe<IntOperationFilterInput>;
  documentReferences?: InputMaybe<ListFilterInputTypeOfDocumentReferenceFilterInput>;
  id?: InputMaybe<IdOperationFilterInput>;
  modifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RequirementFilterInput>>;
  requirementId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<RequirementStatusOperationFilterInput>;
  systemLevelRefs?: InputMaybe<ListFilterInputTypeOfEntityRefOfSystemLevelFilterInput>;
  translations?: InputMaybe<ListFilterInputTypeOfTranslationObjectFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
  willBeAnonymized?: InputMaybe<BooleanOperationFilterInput>;
};

export type RequirementFilterOptions = {
  __typename?: 'RequirementFilterOptions';
  categoryOptions: Array<FilterOption>;
  createdByOptions: Array<FilterOption>;
  keywordOptions: Array<FilterOption>;
  marketOptions: Array<FilterOption>;
  regDocOptions: Array<FilterOption>;
  regOptions: Array<FilterOption>;
  requirementOptions: Array<FilterOption>;
  statusOptions: Array<FilterOption>;
  systemLevelOptions: Array<FilterOption>;
  tagOptions: Array<FilterOption>;
  vexClusterOptions: Array<FilterOption>;
};

export type RequirementPayload = {
  __typename?: 'RequirementPayload';
  requirement: Requirement;
};

export type RequirementSortInput = {
  anonymous?: InputMaybe<SortEnumType>;
  approvalWorkFlow?: InputMaybe<ApprovalWorkFlowSortInput>;
  category?: InputMaybe<SortEnumType>;
  changeType?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  dateEffective?: InputMaybe<SortEnumType>;
  dateExpiration?: InputMaybe<SortEnumType>;
  definition?: InputMaybe<SortEnumType>;
  deletionPeriod?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  requirementId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
  willBeAnonymized?: InputMaybe<SortEnumType>;
};

export enum RequirementStatus {
  Approval = 'APPROVAL',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Final = 'FINAL',
  Interim = 'INTERIM',
  InterimCompleted = 'INTERIM_COMPLETED',
  Modified = 'MODIFIED'
}

export type RequirementStatusOperationFilterInput = {
  eq?: InputMaybe<RequirementStatus>;
  in?: InputMaybe<Array<RequirementStatus>>;
  neq?: InputMaybe<RequirementStatus>;
  nin?: InputMaybe<Array<RequirementStatus>>;
};

export type RequirementsCount = {
  __typename?: 'RequirementsCount';
  final: Scalars['Int'];
  interim: Scalars['Int'];
};

export type RequirementsInfinityResults = {
  __typename?: 'RequirementsInfinityResults';
  requirementFilterOptions: RequirementFilterOptions;
  requirementIds: Array<Scalars['String']>;
  requirementsBatch: Array<Requirement>;
};

export type Simulation = Entity & NamedEntity & Node & {
  __typename?: 'Simulation';
  assignedRequirements: Array<Requirement>;
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  derivatives: Array<Scalars['String']>;
  earliestSOP?: Maybe<Scalars['DateTime']>;
  generationReference?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  markets: Array<Market>;
  modelSeriesReference?: Maybe<Scalars['String']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  paragraphs: Array<RegulatoryDocumentParagraph>;
  regulations: Array<Regulation>;
  translations?: Maybe<Array<TranslationObject>>;
  vehicleProjects: Array<SimulationVehicleProject>;
};


export type SimulationNameArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
};

export type SimulationPayload = {
  __typename?: 'SimulationPayload';
  simulation: Simulation;
};

export type SimulationVehicleProject = Entity & NamedEntity & Node & {
  __typename?: 'SimulationVehicleProject';
  activeTypeMarkets: Array<ActiveTypeMarket>;
  anonymous: Scalars['Boolean'];
  attachments?: Maybe<Array<AttachmentRef>>;
  bodyworkVariants: Array<BodyworkVariant>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  deletionPeriod: Scalars['Int'];
  derivative?: Maybe<Scalars['String']>;
  detVsi?: Maybe<Scalars['Date']>;
  driveVariants: Array<DriveVariant>;
  engineVariants: Array<EngineVariant>;
  eopVsi?: Maybe<Scalars['Date']>;
  euLegislation?: Maybe<Scalars['Boolean']>;
  gearboxVariants: Array<GearboxVariant>;
  generation: Scalars['String'];
  id: Scalars['ID'];
  isElectro?: Maybe<Scalars['Boolean']>;
  isManuallyCreated: Scalars['Boolean'];
  markets: Array<Market>;
  modelSeries: Scalars['String'];
  modelYear?: Maybe<Scalars['Int']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  p10Vsi?: Maybe<Scalars['Date']>;
  posEtVsi?: Maybe<Scalars['Date']>;
  posVsi?: Maybe<Scalars['Date']>;
  sopVsi?: Maybe<Scalars['Date']>;
  sosVsi?: Maybe<Scalars['Date']>;
  sysgenVsi?: Maybe<Scalars['Date']>;
  technology?: Maybe<Scalars['String']>;
  typStartVsi?: Maybe<Scalars['Date']>;
  willBeAnonymized: Scalars['Boolean'];
  wvtaVsi?: Maybe<Scalars['Date']>;
};

export type SortArgsInput = {
  preFilteredIds: Array<Scalars['String']>;
  sortField: Scalars['String'];
};

export type SortArgsParagraphsInput = {
  preFilteredParagraphIds: Array<InfinityParagraphIdInput>;
  sortField: Scalars['String'];
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StandardPlusPcmsCluster = Entity & NamedEntity & Node & {
  __typename?: 'StandardPlusPcmsCluster';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
};

export type StandardPlusPcmsClusterSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Subscription = Entity & NamedEntity & Node & {
  __typename?: 'Subscription';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  keywordRefs: Array<EntityRefOfKeyword>;
  keywords: Array<Keyword>;
  marketRefs: Array<EntityRefOfMarket>;
  markets: Array<Market>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  notificationFormat: NotificationFormat;
  notificationFrequency: NotificationFrequency;
  notificationLang: NotificationLang;
  optOnlyForMainKeywords?: Maybe<Scalars['Boolean']>;
  pogisInterested?: Maybe<Scalars['Boolean']>;
  standardPlusPcmsClusterRefs: Array<EntityRefOfStandardPlusPcmsCluster>;
  standardPlusPcmsClusters: Array<StandardPlusPcmsCluster>;
};

export type SubscriptionPayload = {
  __typename?: 'SubscriptionPayload';
  subscription: Subscription;
};

export type SuggestDocumentResult = {
  __typename?: 'SuggestDocumentResult';
  paragraphs: Array<RegulatoryDocumentParagraph>;
  regulatoryDocuments: Array<RegulatoryDocument>;
  searchHints: Array<Scalars['String']>;
};

export type SuggestRegulationResult = {
  __typename?: 'SuggestRegulationResult';
  regulations: Array<Regulation>;
  searchHints: Array<Scalars['String']>;
};

export type SyncNewVexClustersInput = {
  keywordId: Scalars['ID'];
  newVexClusterIds: Array<Scalars['ID']>;
};

export type SyncNewVexClustersPayload = {
  __typename?: 'SyncNewVexClustersPayload';
  taskId: Scalars['String'];
};

export type SystemLevel = Entity & NamedEntity & Node & {
  __typename?: 'SystemLevel';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  translations?: Maybe<Array<TranslationObject>>;
};


export type SystemLevelNameArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
};

export type TableConfiguration = {
  __typename?: 'TableConfiguration';
  columns: Array<Column>;
  tableId: Scalars['String'];
};

export type Tag = Entity & NamedEntity & Node & {
  __typename?: 'Tag';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  translations?: Maybe<Array<TranslationObject>>;
};


export type TagNameArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
};

export type TargetCollection = {
  __typename?: 'TargetCollection';
  entityId?: Maybe<Scalars['ID']>;
  entityType?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
};

export type TargetCollectionInput = {
  entityId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
};

export enum TextPosition {
  Subscript = 'SUBSCRIPT',
  Superscript = 'SUPERSCRIPT'
}

export type TopicManagementSummary = {
  __typename?: 'TopicManagementSummary';
  quarter: TopicManagementSummaryQuarter;
  year: Scalars['Int'];
};

export type TopicManagementSummaryFilterInput = {
  and?: InputMaybe<Array<TopicManagementSummaryFilterInput>>;
  or?: InputMaybe<Array<TopicManagementSummaryFilterInput>>;
  quarter?: InputMaybe<TopicManagementSummaryQuarterOperationFilterInput>;
  year?: InputMaybe<IntOperationFilterInput>;
};

export type TopicManagementSummaryInput = {
  quarter: TopicManagementSummaryQuarter;
  year: Scalars['Int'];
};

export enum TopicManagementSummaryQuarter {
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4'
}

export type TopicManagementSummaryQuarterOperationFilterInput = {
  eq?: InputMaybe<TopicManagementSummaryQuarter>;
  in?: InputMaybe<Array<TopicManagementSummaryQuarter>>;
  neq?: InputMaybe<TopicManagementSummaryQuarter>;
  nin?: InputMaybe<Array<TopicManagementSummaryQuarter>>;
};

export type TopicManagementSummarySortInput = {
  quarter?: InputMaybe<SortEnumType>;
  year?: InputMaybe<SortEnumType>;
};

export enum TransferStatus {
  ChangesAvailableToTransfer = 'CHANGES_AVAILABLE_TO_TRANSFER',
  TransferNotSet = 'TRANSFER_NOT_SET',
  TrasferedToCodebeamer = 'TRASFERED_TO_CODEBEAMER'
}

export type TransferWorkflow = {
  __typename?: 'TransferWorkflow';
  transferTime?: Maybe<Scalars['DateTime']>;
  transferToCodebeamer: Scalars['Boolean'];
};

export type TransferWorkflowInput = {
  transferTime?: InputMaybe<Scalars['DateTime']>;
  transferToCodebeamer: Scalars['Boolean'];
};

export enum TranslationLang {
  De = 'DE',
  En = 'EN'
}

export type TranslationLangOperationFilterInput = {
  eq?: InputMaybe<TranslationLang>;
  in?: InputMaybe<Array<TranslationLang>>;
  neq?: InputMaybe<TranslationLang>;
  nin?: InputMaybe<Array<TranslationLang>>;
};

export type TranslationObject = {
  __typename?: 'TranslationObject';
  lang: TranslationLang;
  translation: Scalars['String'];
};

export type TranslationObjectFilterInput = {
  and?: InputMaybe<Array<TranslationObjectFilterInput>>;
  lang?: InputMaybe<TranslationLangOperationFilterInput>;
  or?: InputMaybe<Array<TranslationObjectFilterInput>>;
  translation?: InputMaybe<StringOperationFilterInput>;
};

export type TranslationObjectInput = {
  lang: TranslationLang;
  translation: Scalars['String'];
};

export type UpdateActiveTypeMarketInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateActiveTypeMarketPayload = {
  __typename?: 'UpdateActiveTypeMarketPayload';
  activeTypeMarket?: Maybe<ActiveTypeMarket>;
};

export type UpdateAttachmentCategoryInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateAttachmentCategoryPayload = {
  __typename?: 'UpdateAttachmentCategoryPayload';
  attachmentCategory?: Maybe<AttachmentCategory>;
};

export type UpdateBaselineInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  transferWorkflow: TransferWorkflowInput;
};

export type UpdateBodyworkVariantInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateBodyworkVariantPayload = {
  __typename?: 'UpdateBodyworkVariantPayload';
  bodyworkVariant?: Maybe<BodyworkVariant>;
};

export type UpdateCategoryInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type UpdateCategoryPayload = {
  __typename?: 'UpdateCategoryPayload';
  category?: Maybe<Category>;
};

export type UpdateConvoluteInput = {
  convoluteType: ConvoluteType;
  gdprRuleRef?: InputMaybe<EntityRefOfGdprRuleInput>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateConvolutePayload = {
  __typename?: 'UpdateConvolutePayload';
  convolute?: Maybe<Convolute>;
};

export type UpdateCountryInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type UpdateCountryPayload = {
  __typename?: 'UpdateCountryPayload';
  country?: Maybe<Country>;
};

export type UpdateDocumentSourceInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type UpdateDocumentSourcePayload = {
  __typename?: 'UpdateDocumentSourcePayload';
  documentSource?: Maybe<DocumentSource>;
};

export type UpdateDriveVariantInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateDriveVariantPayload = {
  __typename?: 'UpdateDriveVariantPayload';
  driveVariant?: Maybe<DriveVariant>;
};

export type UpdateEngineVariantInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateEngineVariantPayload = {
  __typename?: 'UpdateEngineVariantPayload';
  engineVariant?: Maybe<EngineVariant>;
};

export type UpdateEntityAttachmentsResult = {
  __typename?: 'UpdateEntityAttachmentsResult';
  added: Scalars['Int'];
  deleted: Scalars['Int'];
};

export type UpdateGdprRuleInput = {
  anonymize: Scalars['Boolean'];
  deletionPeriod: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateGdprRulePayload = {
  __typename?: 'UpdateGdprRulePayload';
  gdprRule?: Maybe<GdprRule>;
};

export type UpdateGearboxVariantInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateGearboxVariantPayload = {
  __typename?: 'UpdateGearboxVariantPayload';
  gearboxVariant?: Maybe<GearboxVariant>;
};

export type UpdateGlobalAnnouncementInput = {
  activated: Scalars['Boolean'];
  content: Scalars['String'];
  emailNotification: Scalars['Boolean'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  roles: Array<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateIcsCodeInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateIcsCodePayload = {
  __typename?: 'UpdateIcsCodePayload';
  icsCode?: Maybe<IcsCode>;
};

export type UpdateKeywordInput = {
  approverRefs: Array<EntityRefOfUserInput>;
  id: Scalars['ID'];
  inactiveReason?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  regulationClusterRefs: Array<EntityRefOfRegulationClusterInput>;
  sortPriority?: InputMaybe<Scalars['Int']>;
  successorRefs?: InputMaybe<Array<EntityRefOfKeywordInput>>;
  translations?: InputMaybe<Array<TranslationObjectInput>>;
  vexClusterRefs: Array<EntityRefOfVexClusterInput>;
  vkoRefs: Array<EntityRefOfVkoInput>;
};

export type UpdateKeywordPayload = {
  __typename?: 'UpdateKeywordPayload';
  keyword?: Maybe<Keyword>;
};

export type UpdateMarketInput = {
  childrenRefs: Array<EntityRefOfMarketInput>;
  countriesRef: Array<EntityRefOfCountryInput>;
  id: Scalars['ID'];
  name: Scalars['String'];
  regulationNamingTemplates: Array<NamingTemplateInput>;
  regulatoryDocumentNamingTemplates: Array<NamingTemplateInput>;
  sortPriority?: InputMaybe<Scalars['Int']>;
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type UpdateMarketPayload = {
  __typename?: 'UpdateMarketPayload';
  market?: Maybe<Market>;
};

export type UpdateParagraphAttachmentsInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  paragraphIds: Array<Scalars['ID']>;
  regulatoryDocumentId: Scalars['ID'];
};

export type UpdatePermissionGroupInput = {
  company: Scalars['String'];
  id: Scalars['ID'];
  keywordRefs?: InputMaybe<Array<EntityRefOfKeywordInput>>;
  marketRefs?: InputMaybe<Array<EntityRefOfMarketInput>>;
  name: Scalars['String'];
  userRefs?: InputMaybe<Array<EntityRefOfUserInput>>;
};

export type UpdatePogisDocumentAssetInput = {
  attachment: AttachmentInput;
  pogisDocumentId: Scalars['ID'];
};

export type UpdatePogisDocumentInput = {
  associations?: InputMaybe<Array<Scalars['String']>>;
  dates: Array<PogisDateInput>;
  docStatus: Scalars['String'];
  editor: Scalars['String'];
  id: Scalars['ID'];
  keywords: Array<Scalars['String']>;
  linkVersion?: InputMaybe<Scalars['String']>;
  markets: Array<Scalars['String']>;
  pogisId: Scalars['String'];
  regulationStatus: Scalars['String'];
  relatedDocuments?: InputMaybe<Array<Scalars['String']>>;
  shortInfo: Scalars['String'];
  standards?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateProjectRelevanceByRegulationsInput = {
  generation: Scalars['String'];
  isProjectRelevant: Scalars['Boolean'];
  modelSeries: Scalars['String'];
  projectRelevantComments?: InputMaybe<Scalars['String']>;
  regulationIds: Array<Scalars['ID']>;
};

export type UpdateProjectRelevanceByRegulationsPayload = {
  __typename?: 'UpdateProjectRelevanceByRegulationsPayload';
  vehicleProjectMaster?: Maybe<VehicleProjectMaster>;
};

export type UpdateProjectRelevanceByRequirementsInput = {
  generation: Scalars['String'];
  isProjectRelevant: Scalars['Boolean'];
  modelSeries: Scalars['String'];
  projectRelevantComments?: InputMaybe<Scalars['String']>;
  requirementIds: Array<Scalars['ID']>;
};

export type UpdateProjectRelevanceByRequirementsPayload = {
  __typename?: 'UpdateProjectRelevanceByRequirementsPayload';
  vehicleProjectMaster?: Maybe<VehicleProjectMaster>;
};

export type UpdateQuestionCategoryInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type UpdateQuestionCategoryPayload = {
  __typename?: 'UpdateQuestionCategoryPayload';
  questionCategory?: Maybe<QuestionCategory>;
};

export type UpdateReferenceInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  referenceTypes: Array<ReferenceType>;
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type UpdateReferencePayload = {
  __typename?: 'UpdateReferencePayload';
  reference?: Maybe<Reference>;
};

export type UpdateRegulationAttachmentsInput = {
  attachments: Array<AttachmentInput>;
  regulationId: Scalars['ID'];
};

export type UpdateRegulationClusterInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateRegulationClusterPayload = {
  __typename?: 'UpdateRegulationClusterPayload';
  regulationCluster?: Maybe<RegulationCluster>;
};

export type UpdateRegulationInput = {
  hidden: Scalars['Boolean'];
  icsCodeRefs?: InputMaybe<Array<EntityRefOfIcsCodeInput>>;
  id: Scalars['ID'];
  mainKeywordRefs: Array<EntityRefOfKeywordInput>;
  marketRefs: Array<EntityRefOfMarketInput>;
  name: Scalars['String'];
  regulationNumber: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
  standardPlusPcmsClusterRefs: Array<EntityRefOfStandardPlusPcmsClusterInput>;
  summary?: InputMaybe<Scalars['String']>;
};

export type UpdateRegulatoryDocumentAttachmentsInput = {
  attachments: Array<AttachmentInput>;
  regulatoryDocumentId: Scalars['ID'];
};

export type UpdateRegulatoryDocumentInput = {
  dateEffective?: InputMaybe<Scalars['Date']>;
  dateExpiration?: InputMaybe<Scalars['Date']>;
  disassemblyStatus: RegulatoryDocumentDisassemblyStatus;
  documentReferences?: InputMaybe<Array<DocumentReferenceInput>>;
  documentSourceRef?: InputMaybe<EntityRefOfDocumentSourceInput>;
  documentStatus?: InputMaybe<DocumentStatus>;
  finalVersionRef?: InputMaybe<EntityRefOfRegulatoryDocumentInput>;
  id: Scalars['ID'];
  name: Scalars['String'];
  pogisExists?: Scalars['Boolean'];
  pogisRefs: Array<EntityRefOfPogisDocumentInput>;
  predecessorRef?: InputMaybe<EntityRefOfRegulatoryDocumentInput>;
  predecessorRefs: Array<EntityRefOfRegulatoryDocumentInput>;
  regulationRef?: InputMaybe<EntityRefOfRegulationInput>;
  serviceProviderRefs?: InputMaybe<Array<EntityRefOfUserInput>>;
  skipModificationDataUpdate?: InputMaybe<Scalars['Boolean']>;
  status: RegulatoryDocumentStatus;
  successorRef?: InputMaybe<EntityRefOfRegulatoryDocumentInput>;
  summary?: InputMaybe<Scalars['String']>;
  topicManagementSummary?: InputMaybe<TopicManagementSummaryInput>;
  workflow?: InputMaybe<WorkflowInput>;
};

export type UpdateRegulatoryDocumentParagraphBatchInput = {
  paragraphIds: Array<Scalars['ID']>;
  regulatoryDocumentId: Scalars['ID'];
  update: UpdateRegulatoryDocumentParagraphBatchUpdateInput;
};

export type UpdateRegulatoryDocumentParagraphBatchPayload = {
  __typename?: 'UpdateRegulatoryDocumentParagraphBatchPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type UpdateRegulatoryDocumentParagraphBatchUpdateInput = {
  activeTypeMarketRefs?: InputMaybe<Array<EntityRefOfActiveTypeMarketInput>>;
  bodyworkVariantRefs?: InputMaybe<Array<EntityRefOfBodyworkVariantInput>>;
  categoryRefs?: InputMaybe<Array<EntityRefOfCategoryInput>>;
  comprehensive?: InputMaybe<Scalars['Date']>;
  dateNewRegistration?: InputMaybe<Scalars['Date']>;
  dateNewTypes?: InputMaybe<Scalars['Date']>;
  driveVariantRefs?: InputMaybe<Array<EntityRefOfDriveVariantInput>>;
  engineVariantRefs?: InputMaybe<Array<EntityRefOfEngineVariantInput>>;
  gearboxVariantRefs?: InputMaybe<Array<EntityRefOfGearboxVariantInput>>;
  keywordRefs?: InputMaybe<Array<EntityRefOfKeywordInput>>;
  modelYear?: InputMaybe<Scalars['Int']>;
  phaseIn?: InputMaybe<Array<PhaseDateInput>>;
  phaseOut?: InputMaybe<Array<PhaseDateInput>>;
  summary?: InputMaybe<Scalars['String']>;
  tagRefs?: InputMaybe<Array<EntityRefOfTagInput>>;
  vehicleCategoryRefs?: InputMaybe<Array<EntityRefOfVehicleCategoryInput>>;
};

export type UpdateRegulatoryDocumentParagraphInput = {
  paragraphId: Scalars['ID'];
  regulatoryDocumentId: Scalars['ID'];
  update: UpdateRegulatoryDocumentParagraphUpdateInput;
};

export type UpdateRegulatoryDocumentParagraphPayload = {
  __typename?: 'UpdateRegulatoryDocumentParagraphPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type UpdateRegulatoryDocumentParagraphUpdateInput = {
  categoryRefs: Array<EntityRefOfCategoryInput>;
  comprehensive?: InputMaybe<Scalars['Date']>;
  dateNewRegistration?: InputMaybe<Scalars['Date']>;
  dateNewTypes?: InputMaybe<Scalars['Date']>;
  driveVariantRefs: Array<EntityRefOfDriveVariantInput>;
  keywordRefs: Array<EntityRefOfKeywordInput>;
  modelYear?: InputMaybe<Scalars['Int']>;
  phaseIn?: InputMaybe<Array<PhaseDateInput>>;
  phaseOut?: InputMaybe<Array<PhaseDateInput>>;
  summary?: InputMaybe<Scalars['String']>;
  tagRefs: Array<EntityRefOfTagInput>;
  vehicleCategoryRefs: Array<EntityRefOfVehicleCategoryInput>;
};

export type UpdateRegulatoryDocumentParagraphsInput = {
  paragraphUpdates: Array<ParagraphUpdateInput>;
  regulatoryDocumentId: Scalars['ID'];
};

export type UpdateRegulatoryDocumentParagraphsPayload = {
  __typename?: 'UpdateRegulatoryDocumentParagraphsPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type UpdateRegulatoryDocumentStatusInput = {
  documentError?: InputMaybe<Scalars['String']>;
  documentStatus: DocumentStatus;
  regulatoryDocumentId: Scalars['ID'];
};

export type UpdateRegulatoryDocumentStatusPayload = {
  __typename?: 'UpdateRegulatoryDocumentStatusPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type UpdateRequirementAttachmentsInput = {
  attachments: Array<AttachmentInput>;
  requirementId: Scalars['ID'];
};

export type UpdateRequirementInput = {
  activeTypeMarketRefs?: InputMaybe<Array<EntityRefOfActiveTypeMarketInput>>;
  approvalWorkFlow?: InputMaybe<ApprovalWorkFlowInput>;
  bodyworkVariantRefs?: InputMaybe<Array<EntityRefOfBodyworkVariantInput>>;
  category?: InputMaybe<RequirementCategory>;
  changeType?: InputMaybe<RequirementChangeType>;
  definition?: InputMaybe<Scalars['String']>;
  documentReferences?: InputMaybe<Array<DocumentReferenceInput>>;
  driveVariantRefs?: InputMaybe<Array<EntityRefOfDriveVariantInput>>;
  engineVariantRefs?: InputMaybe<Array<EntityRefOfEngineVariantInput>>;
  gearboxVariantRefs?: InputMaybe<Array<EntityRefOfGearboxVariantInput>>;
  id: Scalars['ID'];
  marketRefs?: InputMaybe<Array<EntityRefOfMarketInput>>;
  name: Scalars['String'];
  requirementId?: InputMaybe<Scalars['String']>;
  skipModificationDataUpdate?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<RequirementStatus>;
  systemLevelRefs?: InputMaybe<Array<EntityRefOfSystemLevelInput>>;
  tagRefs?: InputMaybe<Array<EntityRefOfTagInput>>;
  vehicleCategoryRefs?: InputMaybe<Array<EntityRefOfVehicleCategoryInput>>;
  version?: InputMaybe<Scalars['String']>;
  vexClusterRefs: Array<EntityRefOfVexClusterInput>;
};

export type UpdateRequirementsVersionsInput = {
  newVersions: Array<Scalars['String']>;
  requirementRefs: Array<EntityRefOfRequirementInput>;
};

export type UpdateRequirementsVersionsPayload = {
  __typename?: 'UpdateRequirementsVersionsPayload';
  int?: Maybe<Scalars['Int']>;
};

export type UpdateSimulationInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateStandardPlusPcmsClusterInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateStandardPlusPcmsClusterPayload = {
  __typename?: 'UpdateStandardPlusPcmsClusterPayload';
  standardPlusPcmsCluster?: Maybe<StandardPlusPcmsCluster>;
};

export type UpdateSubscriptionInput = {
  id: Scalars['ID'];
  keywordRefs?: InputMaybe<Array<EntityRefOfKeywordInput>>;
  marketRefs?: InputMaybe<Array<EntityRefOfMarketInput>>;
  name: Scalars['String'];
  notificationFormat: NotificationFormat;
  notificationFrequency: NotificationFrequency;
  notificationLang: NotificationLang;
  optOnlyForMainKeywords?: InputMaybe<Scalars['Boolean']>;
  pogisInterested?: InputMaybe<Scalars['Boolean']>;
  standardPlusPcmsClusterRefs?: InputMaybe<Array<EntityRefOfStandardPlusPcmsClusterInput>>;
};

export type UpdateSystemLevelInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type UpdateSystemLevelPayload = {
  __typename?: 'UpdateSystemLevelPayload';
  systemLevel?: Maybe<SystemLevel>;
};

export type UpdateTagInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  translations?: InputMaybe<Array<TranslationObjectInput>>;
};

export type UpdateTagPayload = {
  __typename?: 'UpdateTagPayload';
  tag?: Maybe<Tag>;
};

export type UpdateVehicleCategoryInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateVehicleCategoryPayload = {
  __typename?: 'UpdateVehicleCategoryPayload';
  vehicleCategory?: Maybe<VehicleCategory>;
};

export type UpdateVehicleProjectInput = {
  activeTypeMarketRefs: Array<EntityRefOfActiveTypeMarketInput>;
  bodyworkVariantRefs: Array<EntityRefOfBodyworkVariantInput>;
  deletionPeriod: Scalars['Int'];
  derivative?: InputMaybe<Scalars['String']>;
  detVsi?: InputMaybe<Scalars['DateTime']>;
  driveVariantRefs: Array<EntityRefOfDriveVariantInput>;
  engineVariantRefs: Array<EntityRefOfEngineVariantInput>;
  eopVsi?: InputMaybe<Scalars['DateTime']>;
  euLegislation?: InputMaybe<Scalars['Boolean']>;
  gearboxVariantRefs: Array<EntityRefOfGearboxVariantInput>;
  generation: Scalars['String'];
  isElectro?: InputMaybe<Scalars['Boolean']>;
  marketRefs: Array<EntityRefOfMarketInput>;
  modelSeries: Scalars['String'];
  modelYear?: InputMaybe<Scalars['Int']>;
  p10Vsi?: InputMaybe<Scalars['DateTime']>;
  posEtVsi?: InputMaybe<Scalars['DateTime']>;
  posVsi?: InputMaybe<Scalars['DateTime']>;
  sopVsi: Scalars['DateTime'];
  sosVsi?: InputMaybe<Scalars['DateTime']>;
  sysgenVsi?: InputMaybe<Scalars['DateTime']>;
  typStartVsi?: InputMaybe<Scalars['DateTime']>;
  willBeAnonymized: Scalars['Boolean'];
  wvtaVsi?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateVexClusterAssignmentBatchInput = {
  keywordId: Scalars['ID'];
  keywordStatus: KeywordStatus;
  paragraphIds: Array<Scalars['ID']>;
  regulatoryDocumentId: Scalars['ID'];
  rejectKeywordReason: Scalars['String'];
  rejectReason: Scalars['String'];
  rejectReasonOption: RejectReasonOption;
  suggestions: Array<UpdateVexClusterSuggestionInput>;
  vexClusterId: Scalars['ID'];
};

export type UpdateVexClusterAssignmentBatchPayload = {
  __typename?: 'UpdateVexClusterAssignmentBatchPayload';
  regulatoryDocument?: Maybe<RegulatoryDocument>;
};

export type UpdateVexClusterInput = {
  approverRefs: Array<EntityRefOfUserInput>;
  id: Scalars['ID'];
  name: Scalars['String'];
  userRefs: Array<EntityRefOfUserInput>;
};

export type UpdateVexClusterPayload = {
  __typename?: 'UpdateVexClusterPayload';
  vexCluster?: Maybe<VexCluster>;
};

export type UpdateVexClusterSuggestionInput = {
  suggestedKeywordId: Scalars['ID'];
  suggestionNote: Scalars['String'];
};

export type UpdateVkoInput = {
  id: Scalars['ID'];
  marketRefs: Array<EntityRefOfMarketInput>;
  userRef: EntityRefOfUserInput;
};

export type UpdateVkoPayload = {
  __typename?: 'UpdateVkoPayload';
  vko?: Maybe<Vko>;
};

export type UploadRegulatoryDocumentAssetInput = {
  assetId: Scalars['String'];
  contentType?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  regulatoryDocumentId: Scalars['ID'];
};

export type UploadRegulatoryDocumentWithAttachmentsError = DoubletError;

export type UploadRegulatoryDocumentWithAttachmentsInput = {
  attachments: Array<AttachmentInput>;
  contentType?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  fileType?: InputMaybe<RegulatoryDocumentFileType>;
  regulatoryDocumentId: Scalars['ID'];
};

export type User = Node & {
  __typename?: 'User';
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mail?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  surname?: Maybe<Scalars['String']>;
  userPrincipalName?: Maybe<Scalars['String']>;
};

export type UserInput = {
  givenName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  mail?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  surname?: InputMaybe<Scalars['String']>;
  userPrincipalName?: InputMaybe<Scalars['String']>;
};

export enum UserRole {
  Avk = 'AVK',
  Bav = 'BAV',
  Bedarfskoordinator = 'BEDARFSKOORDINATOR',
  Pure = 'PURE',
  Readers = 'READERS',
  RegulationReader = 'REGULATION_READER',
  ServiceProvider = 'SERVICE_PROVIDER',
  ShApprover = 'SH_APPROVER',
  SystemAdministrator = 'SYSTEM_ADMINISTRATOR',
  Vex = 'VEX',
  VexSupport = 'VEX_SUPPORT',
  Vko = 'VKO',
  VkoExternal = 'VKO_EXTERNAL'
}

/** A connection to a list of items. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: User;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

export type VehicleCategory = Entity & NamedEntity & Node & {
  __typename?: 'VehicleCategory';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
};

export type VehicleCategorySortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type VehicleProject = Entity & NamedEntity & Node & {
  __typename?: 'VehicleProject';
  activeTypeMarkets: Array<ActiveTypeMarket>;
  anonymous: Scalars['Boolean'];
  attachments?: Maybe<Array<AttachmentRef>>;
  bodyworkVariants: Array<BodyworkVariant>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  deletionPeriod: Scalars['Int'];
  derivative?: Maybe<Scalars['String']>;
  detVsi?: Maybe<Scalars['Date']>;
  driveVariants: Array<DriveVariant>;
  engineVariants: Array<EngineVariant>;
  eopVsi?: Maybe<Scalars['Date']>;
  euLegislation?: Maybe<Scalars['Boolean']>;
  gearboxVariants: Array<GearboxVariant>;
  generation: Scalars['String'];
  id: Scalars['ID'];
  isElectro?: Maybe<Scalars['Boolean']>;
  isManuallyCreated: Scalars['Boolean'];
  markets: Array<Market>;
  modelSeries: Scalars['String'];
  modelYear?: Maybe<Scalars['Int']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  p10Vsi?: Maybe<Scalars['Date']>;
  posEtVsi?: Maybe<Scalars['Date']>;
  posVsi?: Maybe<Scalars['Date']>;
  sopVsi?: Maybe<Scalars['Date']>;
  sosVsi?: Maybe<Scalars['Date']>;
  sysgenVsi?: Maybe<Scalars['Date']>;
  technology?: Maybe<Scalars['String']>;
  typStartVsi?: Maybe<Scalars['Date']>;
  willBeAnonymized: Scalars['Boolean'];
  wvtaVsi?: Maybe<Scalars['Date']>;
};

export type VehicleProjectMaster = Entity & {
  __typename?: 'VehicleProjectMaster';
  assignedRequirementRefs: Array<AssignedRequirementRef>;
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  derivates: Array<Scalars['String']>;
  eopVsi?: Maybe<Scalars['Date']>;
  generation: Scalars['String'];
  id: Scalars['ID'];
  isManuallyCreated: Scalars['Boolean'];
  lastEvaluated?: Maybe<Scalars['Date']>;
  lastTransfer?: Maybe<Scalars['DateTime']>;
  modelSeries: Scalars['String'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  requirementCounts: RequirementsCount;
  sopVsi?: Maybe<Scalars['Date']>;
  transferStatus: TransferStatus;
};

export type VehicleProjectMasterWithProjectDetails = {
  __typename?: 'VehicleProjectMasterWithProjectDetails';
  vehicleProjectMaster: VehicleProjectMaster;
  vehicleProjects: Array<VehicleProject>;
};

export type VehicleProjectPayload = {
  __typename?: 'VehicleProjectPayload';
  vehicleProject: Array<VehicleProject>;
};

export type VexCluster = Entity & NamedEntity & Node & {
  __typename?: 'VexCluster';
  approverRefs: Array<EntityRefOfUser>;
  approvers: Array<User>;
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  userRefs: Array<EntityRefOfUser>;
  users: Array<User>;
};

export type VexClusterAssignment = {
  __typename?: 'VexClusterAssignment';
  keywordStatus: KeywordStatus;
  keywordSuggestions?: Maybe<Array<KeywordSuggestion>>;
  rejectAuthor?: Maybe<User>;
  rejectDate?: Maybe<Scalars['Date']>;
  rejectKeywordReason?: Maybe<Scalars['String']>;
  rejectReason: Scalars['String'];
  rejectReasonOption: RejectReasonOption;
  vexCluster: VexCluster;
};

export type VexClusterAssignmentFilterInput = {
  and?: InputMaybe<Array<VexClusterAssignmentFilterInput>>;
  keywordStatus?: InputMaybe<KeywordStatusOperationFilterInput>;
  keywordSuggestions?: InputMaybe<ListFilterInputTypeOfKeywordSuggestionFilterInput>;
  or?: InputMaybe<Array<VexClusterAssignmentFilterInput>>;
  rejectDate?: InputMaybe<DateTimeOperationFilterInput>;
  rejectKeywordReason?: InputMaybe<StringOperationFilterInput>;
  rejectReason?: InputMaybe<StringOperationFilterInput>;
  rejectReasonOption?: InputMaybe<RejectReasonOptionOperationFilterInput>;
  vexCluster?: InputMaybe<EntityRefOfVexClusterFilterInput>;
};

export type VexClusterAssignmentInput = {
  keywordStatus: KeywordStatus;
  keywordSuggestions?: InputMaybe<Array<KeywordSuggestionInput>>;
  rejectDate?: InputMaybe<Scalars['Date']>;
  rejectKeywordReason?: InputMaybe<Scalars['String']>;
  rejectReason: Scalars['String'];
  rejectReasonOption: RejectReasonOption;
  vexCluster: EntityRefOfVexClusterInput;
};

export type VexClusterFilterInput = {
  and?: InputMaybe<Array<VexClusterFilterInput>>;
  approverRefs?: InputMaybe<ListFilterInputTypeOfEntityRefOfUserFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IdOperationFilterInput>;
  modifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VexClusterFilterInput>>;
  userRefs?: InputMaybe<ListFilterInputTypeOfEntityRefOfUserFilterInput>;
};

export type VexClusterSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type VexWorkbenchItem = {
  __typename?: 'VexWorkbenchItem';
  paragraphCount: Scalars['Int'];
  regulatoryDocument: RegulatoryDocument;
};

export type VexWorkbenchItemClusterData = {
  __typename?: 'VexWorkbenchItemClusterData';
  paragraphCount: Scalars['Int'];
  vexClusterName: Scalars['String'];
};

export type VexWorkbenchItemSimplified = {
  __typename?: 'VexWorkbenchItemSimplified';
  dueDate?: Maybe<Scalars['DateTime']>;
  marketNames: Array<Scalars['String']>;
  regulationId: Scalars['String'];
  regulationName: Scalars['String'];
  regulationNumber: Scalars['String'];
  regulatoryDocumentId: Scalars['String'];
  regulatoryDocumentName: Scalars['String'];
  regulatoryDocumentStatus: RegulatoryDocumentStatus;
  vexClusterData: Array<VexWorkbenchItemClusterData>;
};

export type Vko = Entity & Node & {
  __typename?: 'Vko';
  attachments?: Maybe<Array<AttachmentRef>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  id: Scalars['ID'];
  markets: Array<Market>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy: User;
  name: Scalars['String'];
  vkoUser: User;
};

export type VkoApproverWorkbenchResult = {
  __typename?: 'VkoApproverWorkbenchResult';
  inputItems?: Maybe<Array<RegulatoryDocument>>;
  myScopeDocCount: Scalars['Int'];
  todoItems?: Maybe<Array<RegulatoryDocument>>;
};

export type VkoWorkbenchItem = {
  __typename?: 'VkoWorkbenchItem';
  keywordName: Scalars['String'];
  regulatoryDocumentParagraph: RegulatoryDocumentParagraph;
  rejectAuthor?: Maybe<Scalars['String']>;
  rejectDate?: Maybe<Scalars['DateTime']>;
  rejectKeywordReason: Scalars['String'];
  rejectReason: Scalars['String'];
  vexClusterName: Scalars['String'];
};

export type Workflow = {
  __typename?: 'Workflow';
  clearingTimestamp?: Maybe<Scalars['DateTime']>;
  clearingVKO: Array<User>;
  clearingWithReservationsTimestamp?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  dueDateInProcess?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  processingAuthor: User;
  processingVKO: User;
  processingVKOExternal: User;
  reapprovingAuthor: User;
  reapprovingMessage?: Maybe<Scalars['String']>;
  reapprovingVKO: User;
  status: WorkflowStatus;
};

export type WorkflowFilterInput = {
  and?: InputMaybe<Array<WorkflowFilterInput>>;
  clearingTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  clearingWithReservationsTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  dueDate?: InputMaybe<DateTimeOperationFilterInput>;
  dueDateInProcess?: InputMaybe<DateTimeOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WorkflowFilterInput>>;
  reapprovingMessage?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<WorkflowStatusOperationFilterInput>;
};

export type WorkflowInput = {
  clearingTimestamp?: InputMaybe<Scalars['DateTime']>;
  clearingWithReservationsTimestamp?: InputMaybe<Scalars['DateTime']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateInProcess?: InputMaybe<Scalars['DateTime']>;
  message?: InputMaybe<Scalars['String']>;
  reapprovingMessage?: InputMaybe<Scalars['String']>;
  status: WorkflowStatus;
};

export type WorkflowSortInput = {
  clearingTimestamp?: InputMaybe<SortEnumType>;
  clearingWithReservationsTimestamp?: InputMaybe<SortEnumType>;
  dueDate?: InputMaybe<SortEnumType>;
  dueDateInProcess?: InputMaybe<SortEnumType>;
  message?: InputMaybe<SortEnumType>;
  reapprovingMessage?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export enum WorkflowStatus {
  Archived = 'ARCHIVED',
  Clearing = 'CLEARING',
  ClearingWithReservations = 'CLEARING_WITH_RESERVATIONS',
  Examination = 'EXAMINATION',
  Finalized = 'FINALIZED',
  InProgressExternal = 'IN_PROGRESS_EXTERNAL',
  InProgressInternal = 'IN_PROGRESS_INTERNAL',
  Modified = 'MODIFIED',
  New = 'NEW',
  QualityControlExternal = 'QUALITY_CONTROL_EXTERNAL',
  QualityControlInternal = 'QUALITY_CONTROL_INTERNAL'
}

export type WorkflowStatusOperationFilterInput = {
  eq?: InputMaybe<WorkflowStatus>;
  in?: InputMaybe<Array<WorkflowStatus>>;
  neq?: InputMaybe<WorkflowStatus>;
  nin?: InputMaybe<Array<WorkflowStatus>>;
};
